{
  "nav": {
    "dashboard": "Instrumentpanel",
    "teacherDashboard": "Lärarpanel",
    "projects": "Projekt",
    "fairQuote": "Snabboffert",
    "exitFairQuote": "Avsluta snabboffert",
    "calendar": "Kalender",
    "products": "Produkter",
    "colors": "Färger",
    "company": "Företag",
    "contacts": "Kontakter",
    "applicatorProfiles": "Applikatörer",
    "courses": "Kurser",
    "certifications": "Certifieringar",
    "certificationDefinitions": "Certifieringsdefinitioner",
    "userManagement": "Användarhantering",
    "switchEntity": "Byt enhet",
    "entities": "Enheter",
    "staff": "Personal",
    "overview": "Översikt",
    "sections": {
      "projects": "Projekt",
      "shop": "Butik",
      "learning": "Utbildning",
      "admin": "Administration",
      "entity": "Enhet"
    }
  },
  "materialTracking": {
    "title": "Materialbeställning",
    "status": {
      "Draft": "Att beställa",
      "Ordered": "Beställd",
      "PartiallyDelivered": "Delvis levererad",
      "Delivered": "Levererad"
    },
    "statusLate": "Försenad leverans",
    "late": "FÖRSENAD",
    "markOrdered": "Markera som beställd",
    "markOrderedTitle": "Bekräfta beställning",
    "markOrderedHint": "Registrera att materialet har beställts. Du kan valfritt ange ett uppskattat leveransdatum.",
    "estimatedDelivery": "Uppskattat leveransdatum",
    "estimatedDeliveryPlaceholder": "Välj ett datum",
    "orderedOn": "Beställd den",
    "validateDelivery": "Validera leverans",
    "addDeliveryTitle": "Registrera leverans",
    "addDeliveryHint": "Kontrollera vad som faktiskt mottogs. Justera kvantiteter vid behov och lägg till eller ta bort artiklar.",
    "deliveryComplete": "Fullständig leverans",
    "deliveryPartial": "Delleverans",
    "deliveries": "Leveranser",
    "noLines": "Inga artiklar registrerade",
    "addLine": "Lägg till artikel",
    "confirmDelivery": "Spara leverans",
    "deleteDeliveryTitle": "Ta bort leverans",
    "deleteDeliveryConfirm": "Är du säker på att du vill ta bort denna leveranspost?",
    "addStock": "Lägg till lager",
    "addStockTitle": "Lägg till manuellt lager",
    "manualStock": "Manuellt lager",
    "stockDescription": "beskrivning",
    "stockDescriptionPlaceholder": "t.ex. Säck från tidigare jobb",
    "stockNotesPlaceholder": "t.ex. Från Villa Martin",
    "deleteStockTitle": "Ta bort lagerpost",
    "deleteStockConfirm": "Är du säker på att du vill ta bort denna lagerpost?",
    "productName": "Produkt",
    "quantity": "Antal",
    "unit": "enhet",
    "unitPlaceholder": "t.ex. säck 25 kg",
    "notes": "anteckningar",
    "notesPlaceholder": "Valfri anteckning",
    "deliveryNotesPlaceholder": "t.ex. Skadade artiklar, saknade artiklar",
    "confirmOrder": "Bekräfta beställning",
    "draftHint": "Ingen beställning registrerad än. Klicka på \"Markera som beställd\" när du har lagt beställningen.",
    "productList": "Produkter att beställa",
    "order": "Beställ",
    "orderOnShopify": "Beställ på masmaya.com",
    "orderAlerts": "Beställningsvarningar",
    "daysLate": "{{count}} dag försenad",
    "daysLate_other": "{{count}} dagar försenad",
    "consumption": "Materialbehov",
    "sectionOrderWarningTitle": "Beställning endast för denna sektion",
    "sectionOrderWarningBody": "Att beställa endast för denna sektion kan bli dyrare än för hela projektet: hela projektet når ibland kvantitetsnivåer (säckar på 300 kg eller 1000 kg) som en enskild sektion inte når, särskilt om platsåtkomsten tillåter dessa större format. Kontrollera projektets totalsumma innan du beställer.",
    "sectionOrderWarningConfirm": "Beställ ändå"
  },
  "assignedPeople": {
    "add": "Lägg till person",
    "search": "sök…",
    "noResults": "Inga resultat",
    "replace": "Ersätt",
    "remove": "Ta bort"
  },
  "common": {
    "login": "logga in",
    "error": "Ett fel uppstod",
    "goHome": "gå hem",
    "loading": "laddar...",
    "cancel": "avbryt",
    "create": "Skapa",
    "save": "spara",
    "edit": "redigera",
    "remove": "Ta bort",
    "archive": "Arkivera",
    "delete": "ta bort",
    "open": "Öppna",
    "add": "lägg till",
    "close": "stäng",
    "zoom": "Zooma",
    "back": "Tillbaka",
    "rename": "Byt namn",
    "unsavedChanges": "Osparade ändringar",
    "discardChangesTitle": "Kasta ändringar?",
    "discardChangesConfirm": "Du har osparade ändringar. Är du säker på att du vill kasta dem?",
    "discardChangesAction": "Kasta",
    "view": "Visa",
    "search": "Sök…",
    "tooManyResults": "För många resultat, förfina din sökning",
    "notFound": "Hittades inte",
    "next": "Nästa",
    "confirm": "Bekräfta",
    "selectAll": "Välj alla",
    "deselectAll": "Avmarkera alla",
    "change": "Ändra",
    "total": "Totalt"
  },
  "user": {
    "profile": "Profil",
    "logout": "Logga ut",
    "noEntity": "Ingen enhet vald"
  },
  "products": {
    "title": "Produkter",
    "createButton": "Ny produkt",
    "createTitle": "Skapa produkt",
    "editTitle": "Redigera produkt",
    "importButton": "Importera CSV",
    "shopifySync": {
      "button": "Synkronisera från Shopify",
      "successTitle": "Shopify-synkronisering slutförd",
      "successMessage": "{{updated}} produkter uppdaterade, {{created}} skapade",
      "error": "Shopify-synkronisering misslyckades"
    },
    "searchPlaceholder": "Sök efter namn, variant eller kategori...",
    "allCategories": "Alla kategorier",
    "excludeSamples": "Exkludera prover",
    "noData": "Inga produkter hittades",
    "grouped": "Grupperad",
    "table": "Tabell",
    "columns": {
      "category": "Kategori",
      "name": "namn",
      "variant": "Variant",
      "color": "Färg",
      "sizeWeight": "Storlek / Vikt",
      "dimensions": "Mått",
      "price": "pris (EUR)"
    },
    "form": {
      "category": "Kategori",
      "categoryRequired": "Kategori är obligatorisk",
      "name": "Produktnamn",
      "nameRequired": "Namn är obligatoriskt",
      "variant": "Variant",
      "variantRequired": "Variant är obligatorisk",
      "color": "Färg",
      "sizeWeight": "Storlek / Vikt",
      "dimensions": "Mått",
      "price": "pris (EUR)",
      "priceRequired": "Priset måste vara 0 eller högre",
      "sku": "SKU",
      "imageUrl": "Bild-URL",
      "shopifyVariantId": "Shopify-variant-ID"
    },
    "delete": {
      "title": "Ta bort produkt",
      "confirm": "Är du säker på att du vill ta bort \"{{name}}\"? Denna åtgärd kan inte ångras."
    },
    "import": {
      "title": "Importera produkter från CSV",
      "description": "Ladda upp en tabbavgränsad fil (.csv / .tsv) med följande kolumner:",
      "selectFile": "Välj fil",
      "action": "Importera",
      "success": "Import lyckades",
      "imported": "{{count}} produkter importerade.",
      "close": "stäng"
    },
    "backToList": "Tillbaka till produkter"
  },
  "language": {
    "label": "Språk",
    "en": "Engelska",
    "fr": "Franska",
    "de": "Tyska"
  },
  "pages": {
    "login": {
      "pageTitle": "Logga in"
    },
    "notFound": {
      "message": "Sidan hittades inte",
      "title": "Hoppsan"
    },
    "milestones": {
      "pageTitle": "Milstolpar"
    },
    "staff": {
      "pageTitle": "Personal"
    },
    "taskGeneration": {
      "pageTitle": "Uppgiftsgenerering"
    },
    "quote": {
      "pageTitle": "Offert"
    },
    "roomCalculation": {
      "pageTitle": "Rumsberäkning"
    },
    "company": {
      "pageTitle": "Företag"
    },
    "entityDetail": {
      "pageTitle": "Enhetsdetaljer"
    },
    "entities": {
      "pageTitle": "Enheter"
    }
  },
  "projects": {
    "title": "projekt",
    "createButton": "ny projekt",
    "createTitle": "Skapa projekt",
    "editTitle": "redigera projekt",
    "searchPlaceholder": "Sök efter namn...",
    "allStatuses": "Alla statusar",
    "noData": "Inga projekt hittades",
    "late": "Försenad",
    "noClient": "Ingen kund tilldelad",
    "presentationMode": {
      "enter": "Aktivera presentationsläge (döljer priser och interna anteckningar)",
      "exit": "Avsluta presentationsläge"
    },
    "tracking": {
      "title": "Uppföljning"
    },
    "sequenceGenerator": {
      "title": "Generera uppgiftssekvens",
      "description": "Generera automatiskt en tidsinställd Mas Maya-uppgiftssekvens för ett projektavsnitt.",
      "sectionLabel": "Avsnitt",
      "startDateLabel": "Startdatum",
      "generatingPreview": "Genererar förhandsgranskning…",
      "generatedSequence": "Genererad sekvens",
      "steps": "steg",
      "calendarDays": "kalenderdagar",
      "work": "arbete",
      "dry": "torkning",
      "cure": "härdning",
      "generationFailed": "Generering misslyckades",
      "unexpectedError": "Ett oväntat fel uppstod. Försök igen.",
      "confirmAndGenerate": "Bekräfta och generera",
      "createStepsAndTasks": "Skapa steg och uppgifter",
      "cancel": "Avbryt",
      "premiumFinish": "Premium-finish",
      "repair": "Reparation",
      "highTraffic": "Hög trafik",
      "confirmMessage": "Detta skapar <1>{{stepCount}} projektsteg</1> och <2>{{taskCount}} uppgifter</2> i projektet. Befintliga steg och uppgifter tas inte bort.",
      "taskCount_one": "{{count}} uppgift",
      "taskCount_other": "{{count}} uppgifter",
      "photoLabel": "{{count}}+ foton",
      "stepTypes": {
        "SubstratePreparation": "Underlagsförberedelse",
        "PrimerApplication": "Primerapplikation",
        "BaseLayer": "Grundlager",
        "MeshInstallation": "Nätinstallation",
        "FinishingCoat": "Ytlager",
        "Smoothing": "Utjämning",
        "Presealer": "Presealer",
        "Sealer": "Sealer",
        "HeavyDutySealer": "Heavy-Duty Sealer",
        "CuringStep": "Härdningsperiod",
        "ProtectionPeriod": "Skyddsperiod",
        "Handover": "Överlämning"
      }
    },
    "columns": {
      "name": "namn",
      "status": "status",
      "manager": "Ansvarig",
      "entity": "Enhet",
      "startDate": "start",
      "endDate": "slut"
    },
    "status": {
      "Draft": "Utkast",
      "Planned": "Planerat",
      "InProgress": "Pågående",
      "OnHold": "Pausat",
      "Completed": "Avslutat",
      "Archived": "Arkiverat",
      "AwaitingDelivery": "Inväntar leverans",
      "Blocked": "Blockerat",
      "AwaitingValidation": "Inväntar validering",
      "CorrectionRequired": "Korrigering krävs"
    },
    "executionMode": {
      "ExternalOnly": "DIY-projekt",
      "MasMayaManaged": "Mas Maya Certified Applicator",
      "MasMayaExecuted": "Mas Maya Executed",
      "ExternalOnlyDescription": "Kunden utför arbetena själv",
      "MasMayaExecutedDescription": "Utförs av Mas Maya-team",
      "MasMayaManagedDescription": "Certifierad Mas Maya-applicerare"
    },
    "applicators": {
      "title": "Applikatörsteam",
      "selectLabel": "Lägg till applikatör",
      "selectPlaceholder": "Sök interna applikatörer...",
      "assign": "Tilldela",
      "empty": "Inga applikatörer tilldelade ännu — använd väljaren ovan för att lägga till en.",
      "requiresDates": "Ange planerat start- och slutdatum för projektet innan applikatörer tilldelas.",
      "removeTitle": "Ta bort applikatör",
      "removeConfirm": "Ta bort {{name}} från applikatörsteamet?"
    },
    "sections": {
      "general": "Allmän information",
      "contact": "Primär kontakt",
      "documents": "Dokument"
    },
    "form": {
      "name": "namn",
      "nameRequired": "Namn är obligatoriskt",
      "entity": "Enhet",
      "entityRequired": "Enhet är obligatorisk",
      "manager": "Projektledare",
      "managerRequired": "Projektledare är obligatorisk",
      "managerPlaceholder": "Sök en användare...",
      "managerNoResults": "Inga användare hittades",
      "status": "status",
      "date": "Datum",
      "startTime": "Starttid",
      "endTime": "Sluttid",
      "startDate": "Startdatum",
      "endDate": "Slutdatum",
      "endDateNoSections": "Inga sektioner ännu",
      "endDateCalculating": "Beräknar...",
      "surface": "Total yta (m²)",
      "description": "beskrivning",
      "notes": "anteckningar",
      "primaryContact": "Primär kontakt",
      "primaryContactPlaceholder": "Sök en kontakt...",
      "primaryContactNoResults": "Inga kontakter hittades",
      "primaryContactClear": "— Ta bort kontakt",
      "executionMode": "Utförandeläge",
      "addressLine1": "Adress",
      "city": "Stad",
      "country": "Land",
      "countryRequired": "Land är obligatoriskt",
      "namePlaceholder": "Villa Andersson, Residens Pinen...",
      "projectTypeSubtitle": "Vilken typ av byggprojekt är det?",
      "projectTypeTitle": "Projekttyp",
      "sectionSourceSubtitle": "Du kan alltid lägga till eller importera fler avsnitt senare.",
      "sectionSourceTitle": "Hur vill du skapa avsnitten?"
    },
    "delete": {
      "title": "Ta bort projekt",
      "confirm": "Är du säker på att du vill ta bort \"{{name}}\"? Denna åtgärd kan inte ångras.",
      "action": "ta bort"
    },
    "documents": {
      "dropzoneTitle": "Släpp filer här eller klicka för att ladda upp",
      "dropzoneHint": "Alla filtyper accepteras",
      "preview": "Förhandsgranska",
      "previewUnavailable": "Förhandsgranskning ej tillgänglig för denna filtyp",
      "download": "Ladda ner",
      "rename": "Byt namn",
      "removeTitle": "Ta bort dokument",
      "removeConfirm": "Ta bort \"{{name}}\" från detta projekt?"
    },
    "resources": {
      "title": "Resurser",
      "professionalContacts": "Yrkeskontakter",
      "addTitle": "Lägg till en resurs",
      "email": "e-post",
      "emailPlaceholder": "namn@example.com",
      "displayName": "För- och efternamn",
      "displayNamePlaceholder": "Anna Andersson",
      "role": "Roll",
      "removeTitle": "Ta bort resurs",
      "removeConfirm": "Ta bort {{name}} från detta projekt?",
      "columns": {
        "name": "namn",
        "email": "e-post",
        "role": "Roll",
        "linked": "Konto"
      },
      "empty": "Inga teammedlemmar tilldelade ännu — lägg till en nedan.",
      "linked": "Kopplad",
      "pending": "Väntande",
      "roles": {
        "PM": "Projektledare",
        "Worker": "Arbetare",
        "QualityManager": "Kvalitetsansvarig"
      },
      "noAvailable": "Ingen tillgänglig person att tilldela",
      "certifiedGroup": "Certifierade applikatörer",
      "selectCertifiedCompanies": "Företag med certifierad applikatör"
    },
    "projectSections": {
      "title": "Sektioner",
      "createTitle": "Lägg till en sektion",
      "editTitle": "Redigera sektion",
      "add": "Lägg till sektion",
      "empty": "Inga sektioner ännu",
      "wet": "Våt",
      "submerged": "Nedsänkt",
      "protected": "Skyddad",
      "exterior": "Utomhus",
      "renameFloor": "Byt namn på våning",
      "deleteTitle": "Ta bort sektion",
      "deleteConfirm": "Ta bort sektionen \"{{label}}\"? Detta kan inte ångras.",
      "columns": {
        "label": "Etikett",
        "color": "Färg",
        "type": "Typ",
        "surface": "Yta",
        "finish": "Finish",
        "surfaceM2": "Area",
        "flags": "Alternativ",
        "workers": "Arbetare"
      },
      "stepProgress": "Steg {{current}} av {{total}}"
    },
    "sectionForm": {
      "label": "Etikett",
      "color": "Färg",
      "colorPlaceholder": "Sök en färg...",
      "colorClear": "— Ta bort färg",
      "colorNoResults": "Inga färger hittades",
      "type": "Typ",
      "roomSubtype": "Undertyp",
      "substrate": "Underlag",
      "finish": "Finish",
      "surfaceM2": "Area (m²)",
      "exposure": "Exponering",
      "condition": "Underlagets skick",
      "traffic": "Trafik",
      "insideCornerLinearM": "Innerhörn (lm)",
      "insideCornerHint": "Vik inte väven i innerhörn",
      "outsideCornerLinearM": "Ytterhörn (lm)",
      "outsideCornerHint": "Väv viks 10 cm på varje sida",
      "isCurved": "Böjd yta",
      "isCurvedHint": "Valv, pelare, båge (+15 % spill)",
      "isRepair": "Reparation / mindre lagning",
      "isRepairHint": "Minsta schablonmängder",
      "repairForfaitBadge": "Schablon",
      "workers": "Tilldelade arbetare",
      "workersPlaceholder": "Välj arbetare...",
      "quantityPreview": "Förhandsgranskning av mängd",
      "layerCount": "skikt",
      "meshForcedNotice": "Väv är obligatorisk för denna ytstyp — kan inte inaktiveras",
      "waterproofMembrane": "Tätskikt",
      "waterproofConfirmed": "Finns och är bekräftat",
      "waterproofAbsent": "Saknas eller ej verifierat",
      "waterproofUnknown": "Välj...",
      "waterproofExplanation": "Mas Maya är en vattenavvisande beläggning, inte ett tätskiktssystem. Ett tätskikt (t.ex. Schlüter-KERDI, Aqua-Panel) måste installeras före applicering i våtutrymmen.",
      "waterproofBlockingWarning": "Kan inte spara: ett bekräftat tätskikt krävs för våtutrymmen.",
      "waterproofToPose": "Membran att installera",
      "waterproofWillBeAdded": "Inget tätskikt finns — tätskiktet samt hörn-/rörgenomföringsförstärkningar läggs till i materialkorgen.",
      "insideCornerCount": "Antal inåtgående hörn",
      "insideCornerCountHint": "Antal inåtgående hörnförstärkningar att installera (t.ex. 4 för en rektangulär pool)",
      "outsideCornerCount": "Antal utåtgående hörn",
      "outsideCornerCountHint": "Antal utåtgående hörnförstärkningar att installera",
      "pipePenetrationCount": "Antal rörgenomföringar",
      "pipePenetrationCountHint": "Antal rörgenomföringsförstärkningar att installera",
      "system": {
        "standard1Layer": "Torrt — 1 skikt",
        "premium2Layers": "Torrt — 2 skikt",
        "mesh2Layers": "Väv — 2 skikt",
        "pool": "Pool — Kritiskt system",
        "exterior": "Utomhus — Fasad",
        "exteriorFloor": "Utomhus — Golv / Terrass"
      },
      "riskLevel": {
        "low": "Låg risk",
        "medium": "Måttlig risk",
        "high": "Hög risk",
        "very-high": "Mycket hög risk",
        "critical": "Kritisk risk"
      },
      "warnings": {
        "deterioratedSupport": "Skadat underlag — Förberedelse obligatorisk",
        "tilesAlwaysMesh": "Befintligt kakel — Förberedelse + väv obligatorisk (fogrörelse)",
        "floorMesh": "Golv — Väv + Presealer + Sealer obligatorisk",
        "stepsMeshNosing": "Trappor — Väv viks över trappnos, Presealer + Sealer ingår",
        "brickBlockMesh": "Fogat underlag — Väv obligatorisk",
        "plasterboardMovement": "Gips / mellanvägg — Rörelserisk, väv obligatorisk",
        "wetZone": "Badrum (ingen direkt vattenkontakt) — Väv + skydd obligatorisk",
        "directWaterZone": "Direkt vattenkontakt — Poolprimer väljs automatiskt",
        "waterproofMembraneRequired": "Tätskikt obligatoriskt — måste bekräftas före applicering",
        "masMayaWaterResistant": "Mas Maya är vattenavvisande men inte vattentät — ett tätskikt krävs innan applicering",
        "submergedZone": "Nedsänkt zon — Poolprimer + väv",
        "exteriorExposure": "Utomhusexponering — UV-skydd obligatoriskt",
        "sealingRequired": "Skydd begärt — Presealer + Sealer ingår",
        "heavyDutyRecommended": "Heavy-Duty Sealer rekommenderas för denna ytstyp",
        "poolWaterproofMembrane": "Pool — Tätskikt obligatoriskt före poolprimer",
        "poolWaterline": "Heavy-Duty Sealer obligatorisk vid vattenlinjen (±20 cm)",
        "poolAftercare3Weeks": "Vänta helst 3 veckor innan poolen fylls",
        "exteriorFacadeMesh": "Yttre fasad — Väv + Presealer + Sealer obligatorisk",
        "drainageSlopeWarning": "Kontrollera lutning (min 1,5 %) och dränering före applicering",
        "exteriorHeavyDuty": "Utomhusgolv — Heavy-Duty Sealer obligatorisk (UV- och slitagebeständighet)",
        "curingTime72h": "Sluthärdningstid: minst 72h efter sista sealer-skiktet",
        "furnitureMesh": "Trä / MDF — Rörelserisk, väv obligatorisk",
        "insideCornerNoFold": "Innerhörn — Vik inte väven, kapa och överlappa remsor",
        "outsideCornerMesh": "Ytterhörn — Väv viks 10 cm på varje sida (+0,20 m²/lm)",
        "curvedSurfaceFactor": "Böjd yta — +15 % spill av coating och väv tillämpat",
        "repairForfait": "Reparation — Minsta schablonmängder tillämpade"
      },
      "types": {
        "Wall": "Vägg",
        "Pool": "Pool",
        "Facade": "Fasad",
        "Steps": "Trappor",
        "Furniture": "Möbler / Inbyggt",
        "Room": "Rum"
      },
      "typeDescriptions": {
        "Room": "Rum med golv, väggar och tak",
        "Wall": "Inre väggyta",
        "Pool": "Pool eller nedsänkt bassäng",
        "Facade": "Ytterfasad",
        "Steps": "Trappor eller trappstegsnäsor",
        "Furniture": "Möbler, skåp eller objekt"
      },
      "roomSubtypes": {
        "Bathroom": "Badrum",
        "Default": "Standard"
      },
      "substrates": {
        "Tiles": "Kakel",
        "Concrete": "Betong",
        "Wood": "Trä",
        "Brick": "Tegel",
        "Block": "Lättbetong",
        "Plasterboard": "Gips / mellanvägg"
      },
      "finishes": {
        "Standard": "Standard",
        "Premium": "Premium"
      },
      "protectionLevels": {
        "None": "Ingen",
        "Presealer": "Endast försegling",
        "PresealerSealer": "Försegling + akryllack",
        "PresealerHeavyDutySealer": "Försegling + kraftig lack"
      },
      "exposures": {
        "None": "Ingen",
        "Wet": "Våtrum (badrum — ingen direkt vattenkontakt)",
        "DirectWater": "Direkt vattenkontakt (dusch / handfat / badkar)",
        "Submerged": "Nedsänkt (pool / fontän)",
        "Outside": "Utomhus",
        "WaterProtected": "Vattenskydd (kundönskemål)",
        "SolvantProtected": "Lösningsmedelsskydd Heavy-Duty"
      },
      "conditions": {
        "New": "Nytt",
        "Good": "Gott skick",
        "Normal": "Normal",
        "Deteriorated": "Skadat (förberedelse obligatorisk)"
      },
      "trafficLevels": {
        "None": "Ingen",
        "Low": "Låg",
        "Medium": "Medel",
        "High": "Hög"
      },
      "typeChangeReset": "Vissa fält återställdes eftersom de inte är kompatibla med denna sektionstyp.",
      "underfloorHeating": "Golvvärme",
      "underfloorHeatingPlaceholder": "Ej angiven",
      "underfloorHeatingYes": "Ja — golvvärme finns",
      "underfloorHeatingNo": "Nej — ingen golvvärme",
      "underfloorHeatingType": "Värmetyp",
      "underfloorHeatingUnknown": "Okänd typ",
      "underfloorHeatingWater": "Varmvatten",
      "underfloorHeatingElectric": "Elektrisk",
      "isExteriorRoom": "Exterior",
      "isExteriorRoomHint": "Rummet är exponerat mot utomhusmiljön",
      "isFurnishedRoom": "Möblerat rum",
      "isFurnishedRoomHint": "Innehåller möbler att skydda",
      "isOccupiedSite": "Ockuperad arbetsplats",
      "isOccupiedSiteHint": "Arbetsplatsen är i bruk under arbetet",
      "coatCeiling": "Tak",
      "coatFloor": "Golv",
      "coatWalls": "Väggar",
      "includedSurfaces": "Inkluderade ytor",
      "roomBreakdown": {
        "ceilingM2": "Beräknat tak",
        "floorM2": "Beräknat golv",
        "heightCoefficient": "Höjdkoefficient",
        "heightM": "Höjd",
        "noRoomParams": "Beräkningskonfiguration inte tillgänglig",
        "placeholderHeightWarning": "Höjd ej angiven — 2,5 m används tillfälligt för beräkning",
        "surfaceM2": "Rumsyta",
        "totalM2": "Beräknat totalt:",
        "wallsM2": "Beräknade väggar"
      },
      "roomHeightM": "Höjd (m)",
      "roomHeightPlaceholder": "Höjd ej angiven — 2,5 m används som standard för beräkningar",
      "roomLengthM": "Längd (m)",
      "roomWidthM": "Bredd (m)",
      "selectFinish": "Välj yta...",
      "selectSubstrate": "Välj underlag...",
      "surface": {
        "ceiling": "Tak",
        "floor": "Golv",
        "walls": "Väggar"
      },
      "surfaceConfig": "Konfiguration per yta",
      "steps": {
        "identity": "Identitet",
        "type": "Typ",
        "parameters": "Parametrar",
        "validation": "Validering"
      },
      "identityTitle": "Sektionsidentitet",
      "identitySubtitle": "Namnge denna sektion och koppla en Mas Maya-färg.",
      "typeTitle": "Sektionstyp",
      "typeSubtitle": "Vilken typ av yta vill du konfigurera?",
      "roomConfigTitle": "Rumskonfiguration",
      "roomConfigSubtitle": "Ange dimensioner och ytor som ska behandlas.",
      "standardConfigSubtitle": "Ange de tekniska egenskaperna för denna yta.",
      "summaryTitle": "Sammanfattning",
      "summarySubtitle": "Kontrollera informationen innan sektionen skapas.",
      "colorModes": {
        "SingleColor": "Enskild färg",
        "PerSurface": "Färg per yta"
      },
      "colorPerSurfaceHint": "Välj en färg för varje yta i steget Parametrar.",
      "subtypeLabel": "Rumsundertyp",
      "subtypes": {
        "Default": {
          "label": "Standard",
          "description": "Rum utan specifik konfiguration"
        },
        "Bathroom": {
          "label": "Badrum",
          "description": "Premium-finish + DirectWater-exponering påtvingad"
        },
        "Kitchen": {
          "label": "Kök",
          "description": "Kommer snart"
        },
        "Bedroom": {
          "label": "Sovrum",
          "description": "Kommer snart"
        },
        "SpaHammam": {
          "label": "Spa / Hammam",
          "description": "Kommer snart"
        }
      },
      "comingSoon": "Kommer snart",
      "floorColorLabel": "Golvfärg",
      "wallsColorLabel": "Väggfärg",
      "ceilingColorLabel": "Takfärg",
      "createSection": "Skapa sektion",
      "selectColorPlaceholder": "Välj en färg…",
      "labelPlaceholderRoom": "t.ex. Vardagsrum, Badrum ovanvåning…",
      "surfacesToTreat": "Ytor att behandla",
      "siteCharacteristics": "Platsens egenskaper",
      "createdTitle": "Sektion skapad"
    },
    "consumption": {
      "title": "Produktförbrukning",
      "projectTotal": "Projekttotal",
      "perSection": "Per sektion"
    },
    "materials": {
      "title": "Materialbeställning",
      "projectTotal": "Inköpslista",
      "perSection": "Per sektion",
      "product": "Produkt",
      "qty": "Antal",
      "cost": "Kostnad",
      "noProducts": "Inga produkter att visa",
      "noSections": "Inga sektioner ännu — lägg till en sektion under fliken Sektioner för att se materialbehov.",
      "productNotFound": "Ingen matchande produkt hittades i katalogen",
      "orderOnShopify": "Beställ på masmaya.com",
      "largeVolumeActive": "Storvolymåtkomst aktiv",
      "largeVolumeActiveDesc": "säckar på 300 kg och 1000 kg ingår. Om denna arbetsplats inte kan ta emot pallleveranser, inaktivera storvolymåtkomst i projektinställningarna.",
      "limitedAccess": "Begränsad åtkomst — endast små förpackningar erbjuds.",
      "line": {
        "prep": "Mas Maya Prep",
        "poolPrimer": "Mas Maya Pool Primer",
        "primer": "Mas Maya Primer",
        "coating1Layer": "Mas Maya Coating (1 lager)",
        "coating2Layer": "Mas Maya Coating (2 lager)",
        "mixingWater": "Blandvatten",
        "mesh": "Mas Maya Mesh",
        "presealer": "Mas Maya Presealer",
        "sealer": "Mas Maya Sealer",
        "heavyDutySealer": "Mas Maya Heavy-Duty Sealer",
        "waterproofMembrane": "Waterproof Membrane",
        "waterproofCornerReinforcement": "Waterproof Corner Reinforcement",
        "waterproofPipeReinforcement": "Waterproof Pipe Reinforcement",
        "pigment": "Pigment {{name}}"
      }
    },
    "quote": {
      "title": "Affärsförslag",
      "breakdown": "Detaljerad uppdelning",
      "copyText": "Kopiera som text",
      "copied": "Kopierat!",
      "materials": "Material",
      "labour": "Arbete",
      "recipientEmail": "Mottagarens e-post",
      "downloadPdf": "Ladda ner som PDF",
      "sendByEmail": "Skicka via e-post",
      "provisionalDimensionsWarning": "En eller flera sektioner använder en preliminär (obekräftad) rumshöjd. Visade mängder och kostnader är vägledande — att skicka e-post och skapa en Holded-offert är inaktiverat tills den verkliga höjden har angetts i sektionen.",
      "provisionalBadge": "Preliminär",
      "pdfError": "Fel vid generering av PDF",
      "emailSuccess": "Affärsförslag skickat via e-post till {{email}}",
      "emailError": "Fel vid skickande av affärsförslag via e-post",
      "showPreview": "Visa affärsförslag",
      "client": "Kund",
      "project": "Projekt",
      "totalSurface": "Total yta: {{surface}} m²",
      "sectionsProgress": "Sektioner: {{done}} / {{total}} klara",
      "estimatedTime": "Uppskattad tid: {{hours}} h",
      "totalEstimated": "Uppskattat totalbelopp",
      "disclaimer": "Detta affärsförslag är vägledande och baseras på uppgifterna i projektet; det kan justeras efter ett tekniskt platsbesök.",
      "sectionsHeading": "Detaljer per sektion",
      "whyTitle": "Varför välja Mas Maya?",
      "whyIntro": "Som specialist på tätskikt och dekorativa beläggningar för pooler, våtrum och fasader utformar Mas Maya system som är hållbara, estetiska och lätta att underhålla.",
      "whyPoint1Title": "Nätverk av certifierade applikatörer",
      "whyPoint1Text": "En installation garanterad av utbildade, Mas Maya-certifierade yrkespersoner i hela Frankrike.",
      "whyPoint2Title": "Premiumytor",
      "whyPoint2Text": "Omsorgsfulla resultat och en bred färgpalett, gjorda för att hålla över tid.",
      "whyPoint3Title": "Skräddarsytt stöd",
      "whyPoint3Text": "DIY, certifierad applikatör eller nyckelfärdigt utförande av våra egna team: du väljer din nivå av stöd.",
      "addSectionToCart": "Lägg till i Mas Maya-varukorgen",
      "addProjectToCart": "Lägg till hela projektet i Mas Maya-varukorgen",
      "timeline": "Appliceringsschema",
      "totals": "Projekttotaler",
      "rawHours": "Råtimmar",
      "adjustedHours": "Justerade timmar",
      "totalRawHours": "Totalt antal råtimmar",
      "totalHours": "Totalt antal timmar (justerat)",
      "noSections": "Inga sektioner med data att offerera.",
      "textHeader": "OFFERT — {{name}}",
      "textSection": "Sektion",
      "complexityLevel": {
        "low": "Låg komplexitet",
        "normal": "Standard",
        "medium": "Medelhög komplexitet",
        "high": "Hög komplexitet"
      },
      "tasks": {
        "prep": "Förberedelse",
        "primer": "Primer",
        "coating": "Beläggning",
        "smoothing": "Slipning / polering",
        "presealer": "Presealer",
        "sealer": "Sealer",
        "heavyDutySealer": "Heavy-Duty Sealer"
      },
      "timelineSteps": {
        "afterPrep": "Efter förberedelse",
        "afterPrimer": "Efter primer",
        "betweenLayers": "Mellan skikt",
        "afterSmoothing": "Efter slipning",
        "afterPresealer": "Efter presealer",
        "afterSealer": "Efter sealer",
        "afterHeavyDutySealer": "Efter Heavy-Duty Sealer",
        "poolFill": "Innan poolen fylls"
      }
    },
    "workflow": {
      "title": "Arbetsstatus",
      "notes": "anteckningar",
      "notesPlaceholder": "Lägg till en anteckning...",
      "photos": "Foton",
      "addPhotos": "Lägg till foton",
      "photoRequired": "Minst ett foto krävs",
      "history": "Historik",
      "approved": "Kvalitet godkänd",
      "status": {
        "InProgress": "Pågående",
        "WorkerDone": "Arbete klart",
        "QualityApproved": "Godkänd"
      },
      "changeType": {
        "WorkerDone": "Arbete klart",
        "QualityApproved": "Godkänd",
        "QualitySkipped": "Kontroll överhoppad",
        "QualityRejected": "Avvisad"
      },
      "workerDone": {
        "title": "Markera som klar",
        "description": "Ladda upp minst ett foto för att bekräfta att arbetet är klart.",
        "action": "Markera som klar",
        "submit": "Bekräfta klart"
      },
      "quality": {
        "title": "Kvalitetskontroll",
        "description": "Granska sektionen och godkänn eller avvisa arbetet.",
        "action": "Kvalitetskontroll",
        "approve": "Godkänn",
        "reject": "Avvisa",
        "skipCheck": "Hoppa över kvalitetskontroll (ingen inspektion behövs)"
      }
    },
    "cards": {
      "sections": "{{done}} / {{total}} sektioner godkända",
      "totalProject": "Projekttotal",
      "labour": "Arbete",
      "materials": "Material",
      "incompleteCalc": "Ofullständig beräkning",
      "materialsShort": "Mat.",
      "labourShort": "Arb."
    },
    "sectionAttrs": {
      "characteristics": "Egenskaper",
      "conditions": "Användningsvillkor",
      "dimensions": "Yta och geometri",
      "roomDimensions": "Rummets mått",
      "conditionsStandard": "Standardvillkor",
      "color": "Färg",
      "noColor": "Ingen färg angiven",
      "surfaceComputed": "Beräknad yta",
      "surfaceComputedHint": "uppdateras efter sparande",
      "surfaceUsed": "Använd yta",
      "surfaceOverridden": "Överskriven yta",
      "surfaceOverride": "Manuell överstyrning",
      "surfaceOverrideHint": "Lämna tomt för att använda den beräknade ytan",
      "surfaceOverridePlaceholder": "Yta i m²",
      "noDimensions": "Inga mått angivna",
      "roomWidth": "Bredd",
      "roomLength": "Längd",
      "roomHeight": "Höjd",
      "coatWalls": "Belägg väggarna",
      "coatCeiling": "Belägg taket",
      "coatFloor": "Belägg golvet",
      "parameters": "Parametrar",
      "siteOccupied": "Ockuperad plats",
      "furnishedRoom": "Möblerat rum",
      "complexityLabel": "komplexitet",
      "furnishedMarkupLabel": "möblerat",
      "occupiedMarkupLabel": "ockuperat",
      "standardFinishDiscountLabel": "standardfinish",
      "editColorsHint": "Ändra färger under Parametrar nedan",
      "coatingSurfaceSuffix": "m² att belägga"
    },
    "bulkColor": {
      "title": "Applicera en färg på alla sektioner",
      "hint": "Den valda färgen tillämpas på alla {{count}} sektion(er) i projektet.",
      "removeAll": "Ta bort färgen från alla sektioner",
      "confirmTitle": "Bekräfta tillämpning",
      "confirmApply": "Applicera färgen «{{color}}» på {{count}} sektion(er)?",
      "confirmRemove": "Ta bort färgen från alla {{count}} sektion(er)?",
      "appliedMessage": "Färgen har tillämpats på de valda sektionerna.",
      "removedMessage": "Färgen har tagits bort från de valda sektionerna."
    },
    "bulkFinishProtection": {
      "title": "Finish och skydd (hela projektet)",
      "hint": "Dessa inställningar gäller alltid hela projektet — materialförbrukning och arbetskostnad beror på dem.",
      "finishLabel": "Finish",
      "protectionLabel": "Skydd",
      "apply": "Tillämpa på hela projektet",
      "confirmTitle": "Bekräfta tillämpning",
      "confirmApplyFinish": "Finish \"{{finish}}\" på {{count}} sektion(er).",
      "confirmApplyProtection": "Skydd \"{{level}}\" på {{count}} sektion(er).",
      "appliedMessage": "Finish och skydd tillämpade på hela projektet."
    },
    "bulkFinish": {
      "title": "Tillämpa en finish på hela projektet",
      "hint": "Detta ändrar finishen för alla sektioner i projektet — materialförbrukningen skiljer sig beroende på finish.",
      "lockedSectionsHint": "{{count}} sektion(er) med låst finish (t.ex. trappor, alltid Premium) påverkas inte.",
      "confirmCheckboxLabel": "Jag förstår att detta gäller hela projektet",
      "apply": "Tillämpa på hela projektet",
      "confirmTitle": "Bekräfta tillämpning",
      "confirmApply": "Tillämpa finishen \"{{finish}}\" på projektets {{count}} sektion(er)?",
      "appliedMessage": "Finish tillämpad på hela projektet."
    },
    "bulkProtection": {
      "title": "Tillämpa en skyddsnivå på hela projektet",
      "hint": "Detta ändrar skyddsnivån (försegling / lack) för alla lämpliga sektioner i projektet — det påverkar både materialkostnad och arbetskostnad.",
      "lockedSectionsHint": "{{count}} sektion(er) (pooler eller områden i direkt/nedsänkt vattenkontakt) behåller alltid sitt obligatoriska skydd och påverkas inte. Rums golv behåller också alltid sitt automatiska skydd.",
      "confirmCheckboxLabel": "Jag förstår att detta gäller hela projektet",
      "apply": "Tillämpa på hela projektet",
      "confirmTitle": "Bekräfta tillämpning",
      "confirmApply": "Tillämpa skyddsnivån \"{{level}}\" på projektets {{count}} sektion(er)?",
      "appliedMessage": "Skyddsnivå tillämpad på hela projektet."
    },
    "bulkType": {
      "title": "Tillämpa en typ på alla sektioner",
      "hint": "Den valda typen tillämpas på alla {{count}} sektion(er) på detta våningsplan.",
      "confirmTitle": "Bekräfta tillämpning",
      "confirmApply": "Tillämpa typen \"{{type}}\" på {{count}} sektion(er)?",
      "coatingStep": "Ytor att belägga",
      "descriptions": {
        "Room": "Rum med golv, väggar och tak",
        "Wall": "Inre väggyta",
        "Pool": "Pool eller nedsänkt bassäng",
        "Facade": "Yttre fasad",
        "Steps": "Trappor eller trappnos",
        "Furniture": "Möbler, skåp eller föremål"
      }
    },
    "bulkExclude": {
      "title": "Uteslut sektioner från beräkning",
      "hint": "Markerade sektioner utesluts från material- och arbetsberäkningen.",
      "apply": "Tillämpa",
      "selectAll": "Markera alla",
      "selectNone": "Avmarkera alla",
      "banner": "{{count}} sektion(er) utesluten(a) från beräkning"
    },
    "extractPlan": {
      "title": "Extrahera från ritning",
      "hint": "Ladda upp en arkitektritning för att automatiskt extrahera rum och deras mått.",
      "dropZone": "Klicka för att välja en ritning (JPG, PNG, PDF...)",
      "extract": "Analysera ritning",
      "noPlans": "Inga planer uppladdade ännu. Lägg till bilder eller en PDF ovan.",
      "uploading": "Laddar upp...",
      "partialError": "{{count}} sida(or) kunde inte analyseras.",
      "noRoomsFound": "Inga rum hittades. Prova med en tydligare bild.",
      "converting": "Konverterar PDF...",
      "extracting": "Analyserar...",
      "error": "Analysen misslyckades. Kontrollera att bilden är läsbar och försök igen.",
      "selectHint": "{{count}} rum upptäckta. Välj de som ska bli sektioner.",
      "confidence": "konfidenspoäng",
      "heightHint": "Höjd synlig på ritningen eller att ange manuellt",
      "applyHeightToAll": "Höjd för alla rum",
      "createSections": "Skapa {{count}} sektion(er)",
      "creating": "Skapar sektioner...",
      "generatingTasks": "Genererar uppföljningsuppgifter...",
      "done": "{{count}} sektion(er) skapade!",
      "tasksGenerated": "{{count}} uppföljningsuppgift(er) genererad(e).",
      "surfaceType": "Vilken yttyp vill du konfigurera?"
    },
    "tasks": {
      "form": {
        "title": "Titel",
        "titlePlaceholder": "Uppgiftens titel",
        "category": "Kategori",
        "priority": "Prioritet",
        "plannedStart": "Planerat startdatum",
        "plannedEnd": "Planerat slutdatum",
        "datePlaceholder": "Välj datum",
        "tabDescription": "Beskrivning",
        "tabTechnical": "Teknisk anteckning",
        "tabInternal": "Intern anteckning",
        "tabClient": "Kundanteckning",
        "descriptionPlaceholder": "Uppgiftsbeskrivning...",
        "technicalPlaceholder": "Tekniska anteckningar...",
        "internalPlaceholder": "Interna anteckningar (ej synliga för kund)...",
        "clientPlaceholder": "Kundinstruktioner...",
        "validationRequired": "Validering krävs",
        "weatherSensitive": "Väderkänslig",
        "clientVisible": "Synlig för kund",
        "internalOnly": "Endast intern",
        "mandatoryPhoto": "Obligatoriska foton",
        "minPhotos": "Min. foton",
        "create": "Skapa uppgift",
        "save": "Spara",
        "cancel": "Avbryt",
        "generatedWarning": "Denna uppgift genererades automatiskt. Att redigera detta formulär markerar uppgiften som manuellt ändrad.",
        "rejectionTitle": "Ämne för avslag",
        "rejectionTitlePlaceholder": "T.ex. Ej konforme textur",
        "rejectionReason": "Detaljerad anledning",
        "rejectionReasonPlaceholder": "T.ex. Vänster zon har för synlig kornskillnad...",
        "confirmRejection": "Bekräfta avslag",
        "validationNotes": "Valideringsanteckningar (valfritt)",
        "validationNotesPlaceholder": "Anteckningar för ärendet...",
        "blockingType": "Blockeringstyp",
        "blockingTypeInternal": "Intern (material, planering, team...)",
        "blockingTypeExternal": "Extern (andra hantverkare, kund, väder...)",
        "blockingReason": "Blockeringsskäl",
        "blockingReasonHint": "Förklara vad som måste hända för att låsa upp den här uppgiften – läsaren ska veta exakt vad som krävs."
      },
      "source": {
        "Generated": "Genererad",
        "Modified": "Ändrad",
        "Manual": "Manuell"
      },
      "actions": {
        "title": "Åtgärder",
        "start": "Starta uppgift",
        "requestReview": "Begär validering",
        "resubmit": "Skicka in igen",
        "validate": "Validera uppgift",
        "reject": "Avvisa uppgift",
        "unblock": "Avblockera uppgift",
        "block": "Blockera uppgift",
        "addPhotos": "Lägg till foton",
        "edit": "Redigera uppgift"
      },
      "status": {
        "Todo": "Att göra",
        "Active": "Pågående",
        "ReviewRequested": "Under granskning",
        "Completed": "Validerad",
        "CorrectionRequired": "Korrigering krävs",
        "Blocked": "Blockerad",
        "todoMessage": "Denna uppgift är ännu inte aktiv. Den startar automatiskt när föregående uppgift valideras.",
        "awaitingValidation": "Väntar på validering av ansvarig.",
        "blockedLabel": "Blockerad",
        "blockedWhoInternal": "{{name}} måste agera för att låsa upp detta",
        "blockedWhoInternalFallback": "Ditt team",
        "blockedWhoExternal": "Väntar på en extern åtgärd (kund, leverantör, annat yrke)",
        "completedLabel": "Uppgift validerad",
        "correctionRequired": "Uppgift avvisad",
        "instructions": "Instruktioner: {{instructions}}",
        "submittedPhotos": "Inlämnade foton",
        "requestReviewTitle": "Lägg till minst {{count}} foto(n) innan du begär validering",
        "resubmitTitle": "Lägg till minst {{count}} foto(n) innan du skickar in igen"
      },
      "photos": {
        "title": "Foton",
        "required": "· {{current}}/{{required}} krävs",
        "added": "Foto tillagt",
        "uploadFailed": "Fel vid uppladdning av foto",
        "uploadFailedMessage": "Kan inte skicka filen. Kontrollera formatet eller försök igen."
      },
      "notifications": {
        "validated": "Uppgift validerad",
        "nextTaskStarted": "Nästa uppgift har startat automatiskt.",
        "lastTaskValidated": "Sista uppgiften validerad.",
        "validationError": "Fel",
        "validationErrorMessage": "Kan inte validera uppgiften.",
        "rejected": "Uppgift avvisad",
        "rejectedMessage": "Arbetaren har meddelats och kan korrigera.",
        "rejectionError": "Fel",
        "rejectionErrorMessage": "Kan inte avvisa uppgiften."
      },
      "history": "Historik",
      "deleteTask": {
        "title": "Ta bort uppgift",
        "confirm": "Är du säker på att du vill ta bort <strong>{{name}}</strong>?",
        "action": "Ta bort"
      },
      "editModal": "Redigera uppgift",
      "noTasksForStep": "Inga uppgifter för detta steg.",
      "noTasksForSection": "Inga uppgifter genererade för detta avsnitt.",
      "blockedMessage_one": "Fyll i {{count}} tekniskt fält för att generera arbetsflödet: {{fields}}.",
      "blockedMessage_other": "Fyll i {{count}} tekniska fält för att generera arbetsflödet: {{fields}}.",
      "blockerField": {
        "height": "höjd",
        "substrate": "underlag",
        "waterproofMembrane": "tätskikt"
      },
      "completeConfiguration": "Fyll i sektionens konfiguration",
      "readyToGenerate": "Denna sektion är klar — arbetsflödet har inte genererats än.",
      "generateNow": "Generera uppgifter nu",
      "ungrouped": "Uppgifter utan steg",
      "taskCount_one": "{{count}} uppgift",
      "taskCount_other": "{{count}} uppgifter",
      "completedCount_one": "{{count}} validerad",
      "completedCount_other": "{{count}} validerade",
      "blockedCount_one": "{{count}} blockerad",
      "blockedCount_other": "{{count}} blockerade",
      "deleteSectionTasks": {
        "title": "Ta bort alla uppgifter i avsnittet",
        "confirm": "Ta bort {{count}} uppgift(er) från avsnitt <strong>{{section}}</strong>? Denna åtgärd är oåterkallelig.",
        "action": "Ta bort alla",
        "tooltip": "Ta bort alla uppgifter i detta avsnitt"
      },
      "showPast_one": "Visa {{count}} tidigare uppgift",
      "showPast_other": "Visa {{count}} tidigare uppgifter",
      "showFuture_one": "Visa {{count}} nästa uppgift",
      "showFuture_other": "Visa {{count}} nästa uppgifter",
      "hidePast": "Dölj tidigare uppgifter",
      "hideFuture": "Dölj nästa uppgifter",
      "dateFrom": "Från {{date}}",
      "dateBefore": "Innan {{date}}",
      "stepTypes": {
        "SubstratePreparation": "Underlagsförberedelse",
        "PrimerApplication": "Grundningsläggning",
        "BaseLayer": "Basskikt",
        "MeshInstallation": "Armering",
        "FinishingCoat": "Ytskikt",
        "Smoothing": "Slätning",
        "Presealer": "Försegling",
        "Sealer": "Sealer",
        "HeavyDutySealer": "Kraftig sealer",
        "CuringStep": "Härdning",
        "ProtectionPeriod": "Skyddsperiod",
        "Handover": "Överlämning till kund"
      },
      "sectionTypes": {
        "Wall": "Vägg",
        "Floor": "Golv",
        "Bathroom": "Badrum",
        "Pool": "Pool",
        "Facade": "Fasad",
        "Steps": "Trappor",
        "Furniture": "Möbler",
        "Room": "Rum",
        "Ceiling": "Tak"
      },
      "categories": {
        "preparation": "Förberedelse",
        "primer": "Grundning",
        "mesh": "Armering",
        "base_layer": "Basskikt",
        "finishing_layer": "Ytskikt",
        "smoothing": "Slätning",
        "presealer": "Försegling",
        "sealer": "Sealer",
        "heavy_duty_sealer": "Kraftig sealer",
        "curing": "Härdning",
        "delivery": "Leverans",
        "inspection": "Inspektion",
        "handover": "Överlämning",
        "custom": "Anpassad"
      },
      "priorities": {
        "low": "Låg",
        "normal": "Normal",
        "high": "Hög",
        "critical": "Kritisk"
      },
      "visualStatus": {
        "pending": "Att göra",
        "inProgress": "Pågående",
        "review": "Under granskning",
        "completed": "Validerad",
        "rejected": "Avvisad",
        "blocked": "Blockerad",
        "overdue": "Försenad"
      },
      "blockingType": {
        "Internal": "Intern",
        "External": "Extern"
      },
      "noSectionsMessage": "Skapa ett avsnitt för att automatiskt generera projektuppföljning.",
      "noTasksGeneratedMessage": "Inga uppgifter genererade. Kontrollera de tekniska uppgifterna för dina avsnitt."
    },
    "projectType": {
      "Renovation": "Renoveringsprojekt",
      "RenovationDescription": "Renovering av befintliga ytor",
      "Neuf": "Nybygge",
      "NeufDescription": "Nybyggnation och ytor"
    },
    "sectionSource": {
      "import": "Importera ritningar",
      "importDescription": "Automatisk rumsdetektering från ritningar",
      "manual": "Skapa manuellt",
      "manualDescription": "Definiera dina sektioner en och en"
    },
    "wizard": {
      "steps": {
        "project": "Projekt",
        "mode": "Läge",
        "type": "Typ",
        "logistics": "Logistik"
      },
      "step1": {
        "title": "Nytt projekt",
        "subtitle": "Fyll i grundläggande information för att skapa ditt projekt."
      },
      "step2": {
        "title": "Utförandeläge",
        "subtitle": "Hur kommer detta projekt att utföras?"
      },
      "step3": {
        "title": "Projekttyp",
        "subtitle": "Vad är sammanhanget för detta projekt?"
      },
      "step4": {
        "title": "Tillträde till arbetsplatsen",
        "subtitle": "Är stora palleveranser möjliga på denna arbetsplats?"
      },
      "modes": {
        "ExternalOnly": {
          "label": "GÖR-DET-SJÄLV-projekt",
          "description": "Kunden hanterar utförandet med tillhandahållen information."
        },
        "MasMayaManaged": {
          "label": "Certifierad applikatör",
          "description": "Projekt anförtrodd en Mas Maya certifierad applikatör."
        },
        "MasMayaExecuted": {
          "label": "Utfört av Mas Maya",
          "description": "Projekt utfört direkt av Mas Maya-team."
        }
      },
      "types": {
        "Renovation": {
          "label": "Renovering",
          "description": "Befintlig yta, tillstånd ska bedömas."
        },
        "Neuf": {
          "label": "Nybygge",
          "description": "Ny yta, förifyllda parametrar."
        }
      },
      "access": {
        "large": {
          "label": "Stor volym-tillträde",
          "description": "Palleveranser, 300 kg och 1000 kg behållare möjliga.",
          "hint": "Arbetsplatstillträde kompatibelt med stora volymer och palleveranser.",
          "selectLabel": "Ja — palleveranser möjliga"
        },
        "limited": {
          "label": "Begränsat tillträde",
          "description": "Byggnad, våning, ingen godslyft — endast små förpackningar.",
          "hint": "Begränsat tillträde: stora förpackningar inaktiveras automatiskt.",
          "selectLabel": "Nej — begränsat tillträde, endast små förpackningar"
        },
        "fieldLabel": "Stor volym-tillträde till arbetsplatsen"
      }
    },
    "milestones": {
      "tabTitle": "Förlopp",
      "empty": "Inga milstolpar ännu — de skapas automatiskt allteftersom projektets sektioner och godkännanden fortskrider.",
      "templates": {
        "project_started": "Projekt startat",
        "preparation_completed": "Förberedelse slutförd",
        "surface_approval": "Godkännande av yta",
        "surface_approval_desc": "Din yta är redo för slutlig behandling. Godkänn ytan innan skyddssystemet appliceras.",
        "protection_completed": "Skydd slutfört",
        "delivery": "Leverans",
        "custom": "Ny milstolpe"
      },
      "status": {
        "Pending": "Väntande",
        "AwaitingClient": "Kundgodkännande krävs",
        "Approved": "Godkänd",
        "Completed": "Slutförd",
        "Rejected": "Ändring begärd"
      },
      "approve": "Godkänn",
      "reject": "Begär ändring",
      "rejectComment": "Kommentar (valfritt)",
      "confirmReject": "Bekräfta begäran",
      "approvedByOn": "Godkänd av {{name}} den {{date}}",
      "approvalStale": "Den här sektionen ändrades efter att kunden godkände den – valideringen kanske inte längre återspeglar det aktuella skicket.",
      "clientApproval": {
        "title": "Godkännande av yta",
        "description": "Din yta är redo för slutlig behandling. Godkänn ytan innan skyddssystemet appliceras."
      },
      "payment": {
        "NotDue": "Ej förfallet",
        "Due": "Förfallet",
        "Paid": "Betalt",
        "markPaid": "Markera som betald"
      }
    },
    "holded": {
      "createEstimate": "Skapa offert på Holded",
      "modalDescription": "Välj vad offerten \"{{name}}\" ska innehålla.",
      "creating": "Skapar...",
      "success": "Offert skapad på Holded (ID: {{id}})",
      "error": "Fel vid skapande av Holded-offert"
    },
    "header": {
      "totalCoatingSurfaceTooltip": "Total yta att belägga",
      "totalCoatingSurface": "{{value}} m² att belägga"
    },
    "filters": {
      "allManagers": "Alla projektledare",
      "allExecutionModes": "Alla utförandelägen",
      "lateOnly": "Endast försenade",
      "sortBy": "Sortera efter",
      "sort": {
        "manual": "Manuell ordning",
        "name": "Namn (A–Ö)",
        "deadline": "Deadline, snarast",
        "surface": "Yta, störst",
        "progress": "Framsteg",
        "total": "Totalt värde"
      },
      "clearAll": "Rensa filter"
    },
    "kpi": {
      "total": "Projekt totalt",
      "createdThisMonth_one": "+{{count}} denna månad",
      "createdThisMonth_other": "+{{count}} denna månad",
      "shareOfBook": "{{pct}} % av portföljen",
      "clickToIsolate": "Klicka för att isolera",
      "unassignedPm_one": "{{count}} utan projektledare",
      "unassignedPm_other": "{{count}} utan projektledare",
      "portfolioValue": "Portföljvärde",
      "pricingLoading": "Beräknar…",
      "incompleteCalc_one": "{{count}} ofullständig beräkning",
      "incompleteCalc_other": "{{count}} ofullständiga beräkningar",
      "upToDate": "Fullständigt beräknat",
      "avgProgress": "Genomsn. framsteg",
      "acrossActiveWork_one": "för {{count}} projekt",
      "acrossActiveWork_other": "för {{count}} projekt"
    },
    "list": {
      "surface": "Yta",
      "progress": "Framsteg",
      "total": "Totalt",
      "deadline": "Deadline",
      "lateBy_one": "{{count}}d försenad",
      "lateBy_other": "{{count}}d försenad",
      "unassigned": "Ej tilldelad"
    },
    "bulk": {
      "selectedCount_one": "{{count}} vald",
      "selectedCount_other": "{{count}} valda",
      "selectAll": "Markera alla",
      "changeStatus": "Ändra status",
      "assignPm": "Tilldela projektledare",
      "changeExecutionMode": "Ändra utförandeläge",
      "archive": "Arkivera",
      "archiveTitle": "Arkivera projekt",
      "archiveConfirm_one": "Arkivera {{count}} projekt? Statusen kan ändras igen senare.",
      "archiveConfirm_other": "Arkivera {{count}} projekt? Statusen kan ändras igen senare.",
      "clearSelection": "Rensa markering",
      "statusApplied_one": "{{count}} projekt uppdaterat",
      "statusApplied_other": "{{count}} projekt uppdaterade",
      "pmApplied_one": "{{count}} projekt uppdaterat",
      "pmApplied_other": "{{count}} projekt uppdaterade",
      "executionModeApplied_one": "{{count}} projekt uppdaterat",
      "executionModeApplied_other": "{{count}} projekt uppdaterade",
      "partialFailure": "{{succeeded}} uppdaterade, {{failed}} misslyckades"
    }
  },
  "contacts": {
    "title": "Kontakter",
    "createButton": "Ny kontakt",
    "createTitle": "Skapa kontakt",
    "editTitle": "Redigera kontakt",
    "searchPlaceholder": "Sök efter namn, företag, e-post eller telefon...",
    "allTypes": "Alla typer",
    "noData": "Inga kontakter hittades",
    "columns": {
      "name": "namn",
      "type": "Typ",
      "email": "e-post",
      "phone": "telefon",
      "entity": "Enhet"
    },
    "type": {
      "Individual": "Privatperson",
      "Company": "Företag"
    },
    "status": {
      "active": "aktiv",
      "inactive": "Arkiverad"
    },
    "sections": {
      "general": "Allmän information",
      "contact": "Kontaktuppgifter",
      "projects": "Associated projekt",
      "enrollments": "Kurssessioner",
      "training": "Utbildning & Certifieringar"
    },
    "form": {
      "entity": "Enhet",
      "entityRequired": "Enhet är obligatorisk",
      "type": "Typ",
      "displayName": "Visningsnamn",
      "displayNameRequired": "Visningsnamn är obligatoriskt",
      "firstName": "Förnamn",
      "lastName": "Efternamn",
      "companyName": "Företagsnamn",
      "email": "e-post",
      "phone": "telefon",
      "addressLine1": "adress",
      "addressLine2": "Adress (rad 2)",
      "postalCode": "Postnummer",
      "city": "stad",
      "country": "Land (ISO alpha-2)",
      "notes": "anteckningar"
    },
    "archive": {
      "title": "Arkivera kontakt",
      "confirm": "Är du säker på att du vill arkivera \"{{name}}\"? De kommer inte längre vara synliga som standard.",
      "action": "Arkivera"
    },
    "projectColumns": {
      "name": "projekt",
      "status": "status"
    },
    "enrollmentColumns": {
      "course": "Kurs",
      "date": "Datum",
      "teacher": "Lärare",
      "status": "Status"
    },
    "discount": {
      "sectionTitle": "Rabatt och certifiering",
      "permanentDiscount": "Permanent rabatt",
      "baseDiscount": "Grundrabatt",
      "manualOverride": "Manuell rabattöverstyrning",
      "manualOverrideHint": "Administratörsöverstyrning (10–35 % i steg om 2,5 %). Gäller om högre än den utbildningsbaserade rabatten.",
      "linkedStudent": "Länkat student-ID",
      "linkedStudentHint": "Länka en studentpost för att aktivera certifieringsbaserade rabatter",
      "linked": "Länkad"
    },
    "installer": {
      "sectionTitle": "Refererad installatör",
      "badge": "Refererad installatör",
      "status": "Installatörsstatus",
      "active": "aktiv",
      "inactive": "Ej listad",
      "enable": "Aktivera listning",
      "disable": "Ta bort listning",
      "requirement": "Certifiering",
      "certificationLinked": "Student länkad",
      "certificationRequired": "Ingen student länkad — certifiering krävs"
    },
    "professional": {
      "sectionTitle": "Yrkesinformation",
      "siren": "SIREN",
      "sirenRequired": "SIREN är obligatoriskt",
      "sirenFormat": "SIREN måste vara exakt 9 siffror",
      "sirenNotFound": "Inget företag hittades för detta SIREN",
      "vatNumber": "Momsregistreringsnummer",
      "vatRequired": "Momsregistreringsnummer är obligatoriskt",
      "companyNameHint": "Namn som används av din kontakt (kan skilja sig från det juridiska namnet)",
      "companyNameRequired": "Företagsnamn är obligatoriskt",
      "legalName": "Juridiskt företagsnamn",
      "registeredAddress": "Registrerad adress",
      "companyStatus": "Företagsstatus",
      "statusRadiated": "Avregistrerad",
      "director": "Direktör",
      "activity": "Verksamhet"
    },
    "hierarchy": {
      "link": "Länka",
      "linkToCompany": "Länka till företag",
      "linkedContacts": "Länkade kontakter",
      "noLinkedContacts": "Inga individuella kontakter länkade.",
      "noParentCompany": "Inget moderbolag länkat.",
      "parentCompany": "Moderbolag",
      "selectCompany": "Välj företag...",
      "selectIndividual": "Välj individuell kontakt...",
      "unlink": "Ta bort länk",
      "unlinkConfirm": "Ta bort länken för \"{{name}}\" från detta företag?",
      "unlinkParentConfirm": "Ta bort länken till \"{{name}}\"?",
      "unlinkTitle": "Ta bort kontaktlänk"
    }
  },
  "colors": {
    "title": "Färgväljare",
    "colorCount": "färger",
    "importButton": "Importera CSV-matris",
    "exportButton": "Exportera CSV-matris",
    "importSuccess": "Import lyckades",
    "importSuccessCount": "{{count}} färger importerade.",
    "noData": "Inga färgformler laddade. Importera en CSV-matris för att komma igång.",
    "noCollection": "Övrigt",
    "weight": "Vikt (kg)",
    "weightHint": "Pigmentmängder skalas med vikten",
    "coating": "Coating-bas",
    "pigments": "Pigment",
    "productNotFound": "Produkt hittades inte i katalogen",
    "needed": "behövs:",
    "unit": "enhet",
    "subtotal": "Delsumma:",
    "grandTotal": "totalt",
    "pickColor": "Välj en färg",
    "searchPlaceholder": "Sök färger...",
    "noResults": "Inga färger matchar din sökning",
    "removeColor": "Ta bort färg"
  },
  "courses": {
    "enroll": {
      "search": "Sök kontakter",
      "searchPlaceholder": "Sök på namn eller e-post...",
      "contact": "Kontakt",
      "contactPlaceholder": "Välj en kontakt...",
      "noResults": "Inga kontakter hittades",
      "action": "Registrera"
    }
  },
  "teachers": {
    "title": "Certifierade lärare",
    "createButton": "Ny lärare",
    "createTitle": "Lägg till lärare",
    "editTitle": "Redigera lärare",
    "backToList": "Tillbaka till lärare",
    "searchPlaceholder": "Sök efter namn, e-post eller land...",
    "allStatuses": "Alla statusar",
    "noData": "Inga lärare hittades",
    "inactive": "inaktiv",
    "noCertifiedLevels": "Inga certifierade nivåer",
    "columns": {
      "name": "namn",
      "certification": "Certifiering",
      "levels": "Certifierade nivåer",
      "languages": "Språk",
      "validity": "Giltig till"
    },
    "certificationStatus": {
      "Pending": "Väntande",
      "Active": "aktiv",
      "Expired": "Utgången",
      "Revoked": "Återkallad"
    },
    "form": {
      "fullName": "Fullständigt namn",
      "fullNameRequired": "Fullständigt namn är obligatoriskt",
      "email": "e-post",
      "emailRequired": "E-post är obligatoriskt",
      "country": "Land (ISO alpha-2)",
      "languages": "Språk",
      "certifiedLevels": "Certifierade nivåer",
      "specialties": "Specialiteter",
      "specialtiesPlaceholder": "Pool, Utomhus...",
      "isActive": "Aktiv lärare"
    },
    "certify": {
      "title": "Certifiera lärare",
      "action": "Certifiera",
      "levels": "Nivåer att certifiera",
      "levelsRequired": "Välj minst en nivå",
      "certificationDate": "Certifieringsdatum",
      "expirationDate": "Utgångsdatum",
      "expirationRequired": "Utgångsdatum är obligatoriskt",
      "selfCertifyNote": "En lärare kan inte självcertifiera sig. Denna åtgärd är förbehållen Mas Mayas administratörer.",
      "expired": "Certifiering utgången"
    },
    "revoke": {
      "title": "Återkalla certifiering",
      "confirm": "Är du säker på att du vill återkalla denna lärares certifiering? De kommer inte längre kunna hålla i sessioner.",
      "action": "Återkalla"
    },
    "info": {
      "certification": "Certifiering",
      "profile": "profil",
      "certifiedOn": "Certifierad den",
      "expiresOn": "Går ut den"
    },
    "sessions": {
      "title": "Tilldelade sessioner",
      "empty": "Inga tilldelade sessioner"
    },
    "evaluations": {
      "title": "Elevutvärderingar",
      "student": "student",
      "score": "Poäng",
      "notes": "anteckningar",
      "date": "datum"
    },
    "evaluate": {
      "title": "Utvärdera elev",
      "addButton": "Lägg till utvärdering",
      "action": "Skicka",
      "student": "student",
      "studentPlaceholder": "Välj en elev...",
      "noStudents": "Inga elever hittades",
      "score": "Poäng (1–5)",
      "scoreHint": "1 = behöver förbättras, 5 = utmärkt",
      "notes": "anteckningar"
    }
  },
  "students": {
    "title": "Studenter",
    "createButton": "Ny student",
    "createTitle": "Lägg till student",
    "searchPlaceholder": "Sök efter namn eller e-post...",
    "noData": "Inga studenter hittades",
    "type": {
      "Individual": "Privatperson",
      "Professional": "Yrkesverksam"
    },
    "columns": {
      "name": "namn",
      "email": "e-post",
      "type": "Typ",
      "company": "Företag",
      "country": "land",
      "language": "Språk"
    },
    "form": {
      "firstName": "Förnamn",
      "firstNameRequired": "Förnamn är obligatoriskt",
      "lastName": "Efternamn",
      "lastNameRequired": "Efternamn är obligatoriskt",
      "email": "e-post",
      "emailRequired": "E-post är obligatoriskt",
      "phone": "telefon",
      "type": "Typ",
      "companyName": "Företagsnamn"
    }
  },
  "certifications": {
    "title": "Applikatörscertifieringar",
    "allLevels": "Alla nivåer",
    "allStatuses": "Alla statusar",
    "searchPlaceholder": "Sök efter namn eller e-post...",
    "noData": "Inga certifieringar hittades",
    "viewLevels": "Visa nivådefinitioner",
    "publicPage": "Offentlig sida",
    "status": {
      "Pending": "Väntande",
      "Passed": "Godkänd",
      "Failed": "Underkänd",
      "Expired": "Utgången"
    },
    "columns": {
      "student": "Elev",
      "level": "Nivå",
      "status": "status",
      "issuedAt": "Utfärdad den",
      "expiration": "Går ut den",
      "session": "Session",
      "finishes": "Expertfinisher",
      "certifications": "Certifieringar"
    },
    "issue": {
      "title": "Utfärda certifiering",
      "action": "Utfärda",
      "levelRequired": "Nivå är obligatoriskt",
      "level": "Certifieringsnivå",
      "issuedAt": "Utfärdandedatum",
      "expirationDate": "Utgångsdatum",
      "notes": "anteckningar",
      "basicNote": "Grundcertifieringar valideras automatiskt efter fullständigt deltagande och kan inte underkännas.",
      "allLevelsIssued": "Denna elev har redan certifieringar för alla nivåer.",
      "alreadyIssued": "Certifiering redan utfärdad för denna nivå",
      "absentCannotIssue": "Kan inte utfärda ett certifikat till en frånvarande elev",
      "expertFinishes": "Expertfinisher validerade",
      "terrazzoMetadata": "Terrazzo — bas + 3 inläggningsfärger",
      "terrazzoPlaceholder": "t.ex. Vit bas, svart, guld, rost"
    },
    "update": {
      "title": "Uppdatera certifiering",
      "action": "Spara",
      "status": "status",
      "addFinish": "Validera expertfinish",
      "selectFinish": "Välj en finish...",
      "validateFinish": "Validera finish"
    },
    "levels": {
      "title": "Certifieringsnivåer för applikatörer",
      "subtitle": "Krav och omfång för varje certifieringsnivå",
      "skills": "Appliceringsomfång",
      "products": "Obligatoriska produkter",
      "finishes": "Kreativa finisher",
      "canFail": "Kan underkännas",
      "cannotFail": "Kan inte underkännas",
      "autoValidates": "Valideras automatiskt"
    },
    "levelDefinitions": {
      "basic": {
        "title": "Grundläggande applikatör",
        "skills": {
          "interiorWalls": "Innerväggar",
          "interiorFloors": "Innergolv",
          "interiorCeilings": "Innertak",
          "cleanStableSubstrates": "Rena, stabila underlag"
        }
      },
      "intermediate": {
        "title": "Mellannivå-applikatör",
        "skills": {
          "protectedExteriors": "Skyddade utomhusytor",
          "complexInteriors": "Komplexa inomhusytor",
          "deterioratedSubstrates": "Försämrade underlag",
          "correctivePrep": "Korrigerande förberedelse"
        }
      },
      "expert": {
        "title": "Expertapplikatör",
        "skills": {
          "wetRooms": "Våtrum",
          "showers": "Duschar",
          "bathtubs": "Badkar",
          "pools": "Pooler",
          "fountains": "Fontäner",
          "facades": "Fasader",
          "wetAreas": "Våta zoner"
        }
      },
      "expertFinishes": {
        "title": "Expertapplikatör för finisher",
        "skills": {
          "advancedCreativeFinishes": "Avancerade och kreativa finisher"
        },
        "finishes": {
          "pise": "Pisé (stampad jord)",
          "castConcreteAcetate": "Gjuten betong (acetat)",
          "woodFormworkConcrete": "Betong med träform",
          "burntEffect": "Bränd effekt",
          "brushedConcrete": "Borstad betong",
          "rawSandEffect": "Rå sandeffekt",
          "shouSugiBan": "Shou Sugi Ban",
          "naturalStoneEffect": "Naturstenseffekt",
          "terrazzoEffect": "Terrazzoeffekt (bas + 3 inläggningar)"
        }
      },
      "products": {
        "preparation": "Förberedelse",
        "base": "Bas"
      }
    },
    "public": {
      "subtitle": "{{count}} validerad(e) certifiering(ar)",
      "noData": "Inga certifieringar hittades för denna applikatör.",
      "footer": "Certifierad av Mas Maya · masmaya.fr"
    },
    "admin": {
      "newDefinition": "Ny definition",
      "editDefinition": "Redigera definition",
      "noDefinitions": "Inga definitioner.",
      "form": {
        "name": "Namn",
        "slug": "Slug",
        "slugDescription": "Unik URL-identifierare (t.ex. basic-applicator)",
        "category": "Kategori",
        "prerequisites": "Förkunskaper",
        "description": "Beskrivning",
        "sortOrder": "Visningsordning",
        "isActive": "Aktiv"
      },
      "columns": {
        "name": "Namn",
        "slug": "Slug",
        "category": "Kategori",
        "prerequisites": "Förkunskaper",
        "order": "Ordning",
        "active": "Aktiv"
      }
    }
  },
  "finishEvaluation": {
    "modalTitle": "Expertfinish-utvärdering",
    "evaluateAction": "Utvärdera finish",
    "finishType": "Finishtyp",
    "finishPlaceholder": "Välj en finish...",
    "finishRequired": "Välj en finishtyp",
    "score": "Poäng (0–10)",
    "willFail": "Under godkänd nivå",
    "photos": "Foton",
    "photosBefore": "Foton före",
    "photosDuring": "Foton under arbetet",
    "photosAfter": "Foton efter",
    "dropPhotos": "Släpp bilder eller klicka för att bläddra",
    "photosRequired": "Minst ett foto före och ett foto efter krävs",
    "terrazzoColors": "Terrazzofärger",
    "terrazzoBase": "Basfärg",
    "terrazzoColor1": "Inläggning 1",
    "terrazzoColor2": "Inläggning 2",
    "terrazzoColor3": "Inläggning 3",
    "terrazzoColorsRequired": "Alla fyra terrazzofärger krävs",
    "submit": "Skicka utvärdering",
    "uploading": "Laddar upp foton…",
    "historyTitle": "Expertfinish-utvärderingar",
    "attempts": "{{count}} försök",
    "finishes": {
      "Pise": {
        "label": "Piséeffekt",
        "description": "Lagervis packning som efterliknar traditionellt stampat lertak (pisé)."
      },
      "BetonCoule": {
        "label": "Acetatgjuten betong",
        "description": "Betong gjuten med acetatfolie för en slät, glansig finish."
      },
      "BetonCoffrage": {
        "label": "Formgjuten trähusbetong",
        "description": "Träplanksavtryck i betong för en strukturerad textur."
      },
      "EffetBrule": {
        "label": "Bränd effekt",
        "description": "Mycket fast sten eller stållapp för att skapa en förkolnad textur."
      },
      "BetonBrosse": {
        "label": "Borstad betong",
        "description": "Borstning av färsk betong för att skapa en texturerad yta med räfflor."
      },
      "EffetBrut": {
        "label": "Rå effekt med sandspår",
        "description": "Rå finish som lämnar synliga sandspår på ytan."
      },
      "ShouSugiBan": {
        "label": "Förkolnat trä Shou Sugi Ban",
        "description": "Japansk träbränningsteknik applicerad vid avformning."
      },
      "EffetPierre": {
        "label": "Naturstenseffekt",
        "description": "Imitation av naturstens textur och utseende."
      },
      "EffetTerrazzo": {
        "label": "Terrazzoeffekt",
        "description": "Terrazzo med basfärg och 3 färgade inläggningar."
      }
    }
  },
  "certificates": {
    "title": "Digitala certifikat",
    "status": {
      "Active": "aktiv",
      "Expired": "Utgånget",
      "Revoked": "Återkallat"
    },
    "verify": {
      "title": "Certifikatverifiering",
      "code": "Verifieringskod",
      "level": "Certifieringsnivå",
      "specialties": "Specialiteter",
      "issued": "Utfärdat",
      "expires": "Går ut",
      "revokedOn": "Återkallat den",
      "validNote": "Detta certifikat har utfärdats av Mas Maya och är kryptografiskt verifierbart.",
      "notFound": "Certifikatet hittades inte",
      "notFoundDesc": "Det finns inget certifikat med denna verifieringskod.",
      "link": "Verifiera"
    },
    "revoke": {
      "title": "Återkalla certifikat",
      "confirm": "Är du säker på att du vill återkalla detta certifikat? Denna åtgärd kan inte ångras.",
      "action": "Återkalla",
      "defaultReason": "Återkallad av administratör"
    }
  },
  "evaluation": {
    "modalTitle": "Certifieringsutvärdering",
    "evaluateCertification": "Utvärdera certifiering",
    "selectStudent": "Student",
    "studentPlaceholder": "Välj en student...",
    "studentRequired": "Välj en student",
    "criteria": "Utvärderingskriterier",
    "scoreRange": "Poäng 0–10",
    "finalScore": "Total poäng",
    "willPass": "Kommer att godkännas",
    "willFail": "{{count}} kriterium/kriterier underkänt/underkända",
    "failAlert": "Följande kriterier är under tröskelvärdet: {{criteria}}",
    "teacherNotes": "Lärarens anteckningar",
    "notesPlaceholder": "Observationer, förbättringsområden...",
    "noCriteria": "Inga kriterier definierade för denna nivå",
    "submit": "Skicka utvärdering",
    "history": "Utvärderingshistorik",
    "passed": "Godkänd",
    "failed": "Underkänd",
    "failedCriteria": "Underkända kriterier",
    "retrySessions": "Tillgängliga omprovssessioner",
    "seats": "platser"
  },
  "dashboard": {
    "title": "Översikt",
    "subtitle": "Översikt av din utbildningsaktivitet",
    "upcomingSessions": "Kommande sessioner",
    "stats": {
      "students": "studenter",
      "teachers": "lärare",
      "activeCerts": "Aktiva certifikat",
      "pendingCerts": "Väntande",
      "upcomingSessions": "Kommande (30 dagar)",
      "passedThisYear": "Godkända i år"
    },
    "projectsOverview": {
      "title": "Projekt",
      "active": "Aktiva",
      "blocked": "Blockerade",
      "awaitingValidation": "Väntar på godkännande",
      "late": "Försenade",
      "needsAttention": "Kräver din uppmärksamhet"
    }
  },
  "teacherDashboard": {
    "welcomeLabel": "Välkommen tillbaka",
    "noProfile": "Ingen lärarprofil",
    "noProfileDesc": "Ingen lärarprofil är kopplad till ditt konto.",
    "upcomingSessions": "Dina kommande sessioner",
    "recentEvaluations": "Senaste utvärderingar",
    "noSessions": "Inga tilldelade sessioner",
    "stats": {
      "upcoming": "Kommande",
      "sessions": "Totalt antal sessioner",
      "evaluations": "Utvärderingar"
    }
  },
  "studentPortal": {
    "title": "Studentportal",
    "subtitle": "Kom åt dina utbildningsresultat, certifieringar och kommande sessioner.",
    "emailLabel": "Din e-postadress",
    "emailPlaceholder": "student@exempel.com",
    "lookup": "Kom åt min profil",
    "notFound": "Inget konto hittades",
    "profileLabel": "Min profil",
    "profileNotFound": "Profilen hittades inte",
    "upcomingSessions": "Kommande sessioner",
    "pastSessions": "Tidigare sessioner",
    "footer": "Mas Maya Utbildning · masmaya.fr",
    "privacyNote": "Endast dina utbildningsdata visas. Inget konto eller lösenord krävs."
  },
  "enroll": {
    "title": "Registrera dig för en session",
    "firstName": "Förnamn",
    "lastName": "Efternamn",
    "email": "E-postadress",
    "type": "Typ",
    "company": "Företag / Organisation",
    "country": "Land (2-bokstavskod)",
    "language": "Föredraget språk",
    "seatsLeft": "{{count}} plats(er) kvar",
    "submit": "Registrera",
    "requiredFields": "Fyll i alla obligatoriska fält.",
    "notOpen": "Registrering ej öppen",
    "notOpenDesc": "Denna session är för närvarande inte öppen för registrering.",
    "sessionNotFound": "Sessionen hittades inte",
    "successTitle": "Registrering bekräftad!",
    "successDesc": "Din plats är reserverad. Du kommer att få en bekräftelse via e-post.",
    "viewProfile": "Visa min profil",
    "error": "Ett fel uppstod. Försök igen.",
    "privacyNote": "Dina uppgifter används endast för utbildningsändamål.",
    "professional": {
      "siren": "SIREN-nummer",
      "sirenDesc": "9 siffror — automatisk sökning via Pappers",
      "sirenRequired": "SIREN-nummer krävs (9 siffror).",
      "sirenNotFound": "Företaget hittades inte eller ogiltigt SIREN.",
      "vatNumber": "Momsregistreringsnummer",
      "vatRequired": "Momsregistreringsnummer krävs.",
      "companyRequired": "Företagsnamn är obligatoriskt.",
      "companyNameDesc": "Namn som används kommersiellt (kan skilja sig från det juridiska namnet)",
      "director": "Direktör",
      "radiated": "Företaget upplöst / stängt"
    }
  },
  "cart": {
    "title": "Kundvagn",
    "empty": "Kundvagnen är tom",
    "clear": "Töm kundvagn",
    "clearTitle": "Töm kundvagn",
    "clearConfirm": "Ta bort alla artiklar från denna kundvagn?",
    "clearAction": "Töm",
    "training": "Utbildning",
    "subtotal": "Delsumma",
    "discount": "Rabatt",
    "total": "totalt",
    "columns": {
      "item": "Artikel",
      "unitPrice": "Á-pris",
      "qty": "Antal",
      "total": "totalt"
    },
    "discountReason": {
      "base": "Grundpris",
      "manual_override": "Manuell administratörsrabatt",
      "cart_training_incentive": "Upplåst genom att lägga till utbildning",
      "certification_Basic": "Grundcertifiering",
      "certification_Intermediate": "Mellannivåcertifiering",
      "certification_Expert": "Expertcertifiering",
      "certification_ExpertFinishes": "Expertfinish-certifiering"
    },
    "upsell": {
      "title": "Lås upp en rabatt",
      "addTraining": "Lägg till {{title}} i kundvagnen",
      "level": {
        "Basic": "Grund",
        "Intermediate": "Mellannivå",
        "Expert": "Expert",
        "ExpertFinishes": "Expertfinish"
      }
    }
  },
  "entities": {
    "title": "Enheter",
    "createButton": "Ny enhet",
    "createTitle": "Skapa enhet",
    "editTitle": "Redigera enhet",
    "searchPlaceholder": "Sök efter namn, kod eller land...",
    "showArchived": "Visa arkiverade",
    "noData": "Inga enheter hittades",
    "noUsers": "Inga användare tilldelade",
    "viewUsers": "Visa användare",
    "columns": {
      "name": "namn",
      "code": "Kod",
      "country": "land",
      "status": "status",
      "users": "Användare"
    },
    "status": {
      "active": "aktiv",
      "inactive": "inaktiv"
    },
    "sections": {
      "general": "Allmän information",
      "users": "Tilldelade användare",
      "staff": "Personal"
    },
    "noStaff": "Ingen personal för denna enhet",
    "form": {
      "name": "namn",
      "nameRequired": "Namn är obligatoriskt",
      "code": "Internkod",
      "codePlaceholder": "e.g. CORP-FR",
      "country": "Land (ISO alpha-2)",
      "countryPlaceholder": "Välj ett land",
      "countryRequired": "Land är obligatoriskt",
      "currency": "Valuta (ISO 4217)",
      "timezone": "Tidszon",
      "email": "Kontakt-e-post",
      "logoUrl": "Logotyp-URL",
      "isActive": "aktiv"
    },
    "archive": {
      "title": "Arkivera enhet",
      "confirm": "Är du säker på att du vill arkivera \"{{name}}\"? Den kommer inte längre att vara synlig som standard.",
      "confirm_action": "Arkivera"
    },
    "assignUser": {
      "title": "Tilldela en användare",
      "button": "Tilldela användare",
      "searchLabel": "Sök användare",
      "searchPlaceholder": "Namn eller e-post...",
      "noResults": "Inga användare hittades",
      "selected": "Vald",
      "assign": "Tilldela"
    },
    "removeUser": {
      "title": "Ta bort användare",
      "confirm": "Ta bort {{name}} från denna enhet?"
    },
    "managers": {
      "title": "Ansvariga",
      "role": "Enhetsansvarig",
      "noAvailable": "Inga användare tillgängliga"
    },
    "userColumns": {
      "name": "namn",
      "email": "e-post",
      "assignedOn": "Tilldelad den"
    },
    "quoteConfig": {
      "title": "Offertkonfiguration",
      "subtitle": "Standardvärden som används för förbrukningsberäkning",
      "consumptionRates": "Förbrukningstal",
      "wasteFactors": "Spillfaktorer",
      "labourRates": "Arbetskostnader",
      "complexityMultipliers": "Komplexitetsmultiplikatorer",
      "fields": {
        "coating1LayerKgPerM2": "Coating 1 lager",
        "coating2LayerKgPerM2": "Coating 2 lager",
        "mixingWaterWallLPerKg": "Blandningsvatten (vägg)",
        "mixingWaterFloorLPerKg": "Blandningsvatten (golv)",
        "prepCoverageM2Per10Kg": "Prep",
        "primerCoverageM2PerL": "Primer",
        "poolPrimerCoverageM2PerL": "Pool Primer",
        "presealerCoverageM2PerL": "Presealer",
        "sealerCoverageM2PerL": "Sealer",
        "heavyDutySealerCoverageM2PerL": "Heavy-Duty Sealer",
        "meshWasteFactor": "Mesh-spill (enkel)",
        "meshComplexWasteFactor": "Mesh-spill (komplex)",
        "generalWasteFactor": "Allmänt spill",
        "labourRatePerM2": "Taxa / m²",
        "labourRatePerSurface": "Taxa / yta",
        "labourRatePerProduct": "Taxa / produkt",
        "complexityLow": "Låg",
        "complexityNormal": "Normal",
        "complexityMedium": "Medel",
        "complexityHigh": "Hög",
        "repairMinSurfaceM2": "Min. reparationsyta (m²)",
        "prepMarginPercent": "Marginal Prep",
        "primerMarginPercent": "Marginal Primer",
        "poolPrimerMarginPercent": "Marginal Pool Primer",
        "coatingMarginPercent": "Marginal Coating",
        "meshMarginPercent": "Marginal Mesh",
        "presealerMarginPercent": "Marginal Presealer",
        "sealerMarginPercent": "Marginal Sealer",
        "heavyDutySealerMarginPercent": "Marginal HD Sealer",
        "pigmentMarginPercent": "Marginal Pigment"
      },
      "siteLogistics": "Arbetsplatslogistik",
      "maxSmallAccessCoatingBag": "Max. coating-säckstorlek utan stor volym-tillträde",
      "materialMargin": "Materialmarginal",
      "markups": {
        "title": "Arbetsplatstillägg",
        "occupiedSite": "Ockuperad arbetsplats (%)",
        "furnishedRoom": "Möblerat rum (%)",
        "standardFinishDiscount": "Rabatt standardfinish (%)",
        "standardFinishDiscountHint": "Grundpriserna för arbetskraft är kalibrerade för Premium-finish. Denna rabatt tillämpas när en sektions finish är Standard."
      },
      "degressiveRates": "Degressiva arbetskostnader per m²",
      "addTier": "Lägg till nivå",
      "tierFields": {
        "minSurface": "Min yta",
        "maxSurface": "Max yta",
        "rate": "Taxa (€/m²)",
        "enabled": "Aktiv"
      },
      "taskGenConfig": {
        "title": "Uppgiftsgeneringsvariabler",
        "save": "Spara variabler",
        "saveSuccess": "Uppgiftsgeneringsvariabler sparade.",
        "saveError": "Sparandet misslyckades.",
        "unsavedWarning": "Osparade ändringar. Klicka på Spara för att tillämpa på framtida genereringar.",
        "critical": "Kritisk",
        "taskFamilies": {
          "title": "Aktivera uppgiftsfamiljer",
          "description": "Att inaktivera en familj förhindrar att dessa uppgifter genereras i nya projekt. Befintliga uppgifter tas inte bort.",
          "preparation": "Underlagsförberedelse",
          "primer": "Primer",
          "mesh": "Nät / armering",
          "coating": "Ytlager",
          "drying": "Torktid",
          "presealer": "Presealer",
          "sealer": "Sealer",
          "heavyDuty": "Heavy-Duty Sealer",
          "qualityControl": "Kvalitetskontroll",
          "aftercare": "Eftervård / skydd",
          "handover": "Kundöverlämning (Handover)"
        },
        "substratePrep": {
          "title": "Underlagsförberedelse",
          "inspection": "Underlagsinspektion",
          "surfaceCleaning": "Ytrengjöring",
          "sanding": "Slipning",
          "dustRemoval": "Dammborttagning",
          "maskingProtection": "Skydd av angränsande ytor",
          "crackTreatment": "Sprickbehandling",
          "jointTreatment": "Fogbehandling",
          "maxImperfectionMm": "Max ojämnhet",
          "maxImperfectionHint": "Gräns över vilken en fyllnadsuppgift genereras"
        },
        "primer": {
          "title": "Primer",
          "minWaitMinutes": "Min. väntetid — standard primer",
          "minWaitHint": "Minsta fördröjning innan det första lagret appliceras",
          "maxWindowHours": "Max fönster — standard primer",
          "maxWindowHint": "Lagret måste appliceras innan denna tid",
          "poolMinWaitMinutes": "Min. väntetid — pool primer",
          "poolMinWaitHint": "Pool Primer — minsta väntetid före coating"
        },
        "mixing": {
          "title": "Blandning och lager",
          "mixRestMinutes": "Blandningsvila",
          "mixRestHint": "Vilotid efter blandning innan applicering",
          "wallWaterRatio": "Vattenkvot vägg",
          "floorWaterRatio": "Vattenkvot golv",
          "baseLayerThickness": "Grundlagertjocklek",
          "finishLayerThickness": "Ytlagertjocklek"
        },
        "mesh": {
          "title": "Nät / Armering",
          "overlapCm": "Nätöverlapp",
          "edgeDistanceCm": "Nätkantsavstånd",
          "requiredFor": "Nät krävs för",
          "floors": "Golv",
          "stairs": "Trappor",
          "tiles": "Kakel",
          "wood": "Trä",
          "pools": "Pooler",
          "bathrooms": "Badrum",
          "exteriors": "Fasader / exteriör"
        },
        "waterproofing": {
          "title": "Vattentätning",
          "description": "Mas Maya-beläggning är vattenresistent men inte vattentät. En tätningsduk krävs i följande fall.",
          "wetZones": "Tätningsduk krävs — blöta zoner",
          "wetZonesHint": "Blöta zoner, direkt vattenexponering",
          "pools": "Tätningsduk krävs — pooler",
          "bathrooms": "Tätningsduk krävs — badrum"
        },
        "presealer": {
          "title": "Presealer",
          "numberOfCoats": "Antal lager",
          "waitBetweenCoats": "Väntetid mellan lager"
        },
        "sealer": {
          "title": "Standard sealer",
          "ratioA": "Kvot A",
          "ratioAHint": "Del A av blandningen (t.ex. 5)",
          "ratioB": "Kvot B",
          "ratioBHint": "Del B av blandningen (t.ex. 1)",
          "mixRestMinutes": "Blandningsvila",
          "numberOfCoats": "Antal lager",
          "waitBetweenCoats": "Väntetid mellan lager",
          "fullCureHours": "Fullständig härdning"
        },
        "heavyDuty": {
          "title": "Heavy-Duty Sealer",
          "ratioA": "Kvot A",
          "ratioB": "Kvot B",
          "waitBetweenCoats": "Väntetid mellan lager",
          "fullCureHours": "Fullständig härdning",
          "minTempC": "Min. appliceringstemperatur",
          "maxTempC": "Max. appliceringstemperatur",
          "requiredFor": "Heavy-Duty krävs för",
          "floors": "Golv",
          "stairs": "Trappor",
          "exteriors": "Exteriör",
          "pools": "Pooler",
          "highTraffic": "Högtrafik-zoner"
        },
        "pool": {
          "title": "Poolregler",
          "fillWaitDays": "Väntetid innan fyllning",
          "fillWaitHint": "Minsta tid innan poolen fylls",
          "waterlineMarginCm": "HD vattenlinjemarginal",
          "waterlineMarginHint": "Bredd på Heavy-Duty-zonen runt vattenlinjen"
        },
        "exterior": {
          "title": "Exteriörregler",
          "minTempC": "Min. temperatur",
          "maxTempC": "Max. temperatur"
        },
        "aftercare": {
          "title": "Eftervård och användningsbegränsningar",
          "noWaterDays": "Absolut skydd",
          "noWaterHint": "Ingen kontakt eller fukt",
          "noTrafficDays": "Ingen trafik",
          "lightUseStartDay": "Lätt användning från dag",
          "normalUseAfterDays": "Normal användning efter",
          "resealYearsMin": "Omsealing rekommenderas inom",
          "resealYearsMax": "Omsealing rekommenderas före"
        },
        "layerExceptions": {
          "title": "Enkelt/dubbelt lager-undantag",
          "description": "Standard Mas Maya-systemet är 2 mm grundlager + nät + 2 mm ytlager. Dessa undantag bör endast aktiveras för perfekta torra innerytor.",
          "allowOneLayer": "Tillåt enkellager utan nät",
          "allowOneLayerHint": "Endast perfekta torra innerväggar",
          "oneLayerWalls": "Enkellager tillåtet på väggar",
          "oneLayerCeilings": "Enkellager tillåtet på tak",
          "allowTwoLayer": "Tillåt dubbellager utan nät",
          "allowTwoLayerHint": "Endast stabila strukturerade väggar",
          "twoLayerStableWalls": "Dubbellager utan nät på stabila strukturerade väggar"
        },
        "underfloorHeating": {
          "title": "Golvvärme",
          "warning": "Att ändra omstartsparametrar kan påverka beläggningens prestanda. Ändra bara dessa värden baserat på Mas Mayas tekniska dokumentation.",
          "generationTitle": "Generering",
          "generateTasks": "Generera golvvärmeuppgifter",
          "requireQuestion": "Fråga om golvvärme för golvavsnitt",
          "generateShutdown": "Uppgift: Stäng av golvvärme",
          "generateRestart": "Uppgifter: Starta om golvvärme",
          "generateProgressiveHeatUp": "Progressiv uppvärmning (uppgifter per dag)",
          "generateMonitoring": "Temperaturövervakningsuppgifter",
          "generateClientHandover": "Överlämning av instruktioner till kund",
          "shutdownTitle": "Avstängning före applicering",
          "shutdownBeforeApplication": "Timmar av avstängning före applicering",
          "shutdownBeforeSealer": "Timmar av avstängning före sealer",
          "offDuringApplication": "Golvvärme av under applicering",
          "offDuringCure": "Golvvärme av under härdning",
          "restartTitle": "Progressiv omstart",
          "restartAfterSealer": "Väntetid efter slutlig sealer innan omstart",
          "restartStartTemp": "Starttemperatur",
          "restartTempIncrement": "Ökning per dag",
          "restartMaxTemp": "Maxtemperatur",
          "restartMinDuration": "Minsta uppvärmningstid",
          "restartRequiresValidation": "Validering krävs vid slutförande",
          "controlsTitle": "Kontroller",
          "dailyTempCheck": "Daglig temperaturkontroll",
          "floorSurfaceTempCheck": "Golvytetemperaturkontroll innan omstart",
          "clientWarningRapidHeatUp": "Kundvarning om snabb uppvärmning",
          "restartCompletionQc": "Slutkontroll efter omstart"
        }
      }
    },
    "taskGenConfig": {
      "title": "Uppgiftsgenererings-variabler",
      "save": "Spara variabler",
      "saveError": "Fel vid sparande.",
      "saveSuccess": "Generieringsvariabler sparade.",
      "critical": "Kritisk",
      "unsavedWarning": "Osparade ändringar. Klicka på Spara för att tillämpa dem på framtida generieringar.",
      "aftercare": {
        "title": "Eftervård och användningsbegränsningar",
        "lightUseStartDay": "Lätt användning från dag",
        "noTrafficDays": "Ingen trafik",
        "noWaterDays": "Absolut skydd",
        "noWaterHint": "Ingen kontakt eller fukt",
        "normalUseAfterDays": "Normal användning efter",
        "resealYearsMax": "Ny tätning rekommenderas senast",
        "resealYearsMin": "Ny tätning rekommenderas om"
      },
      "exterior": {
        "title": "Utomhusregler",
        "maxTempC": "Max. temperatur",
        "minTempC": "Min. temperatur"
      },
      "heavyDuty": {
        "title": "Heavy-Duty Sealer",
        "exteriors": "Utomhusytor",
        "floors": "Golv",
        "fullCureHours": "Fullständig härdning",
        "highTraffic": "Zon med hög trafik",
        "maxTempC": "Max. appliceringstemperatur",
        "minTempC": "Min. appliceringstemperatur",
        "pools": "Pooler",
        "ratioA": "Förhållande A",
        "ratioB": "Förhållande B",
        "requiredFor": "Heavy-Duty obligatorisk för",
        "stairs": "Trappor",
        "waitBetweenCoats": "Väntetid mellan lager"
      },
      "layerExceptions": {
        "title": "Undantag för ett/tvålager",
        "description": "Standardsystemet Mas Maya är 2 mm grundlager + mesh + 2 mm finish. Dessa undantag ska bara aktiveras för ideala innerytor i torr miljö.",
        "allowOneLayer": "Tillåt enkellager utan mesh",
        "allowOneLayerHint": "Endast för perfekta, torra innerväggar",
        "allowTwoLayer": "Tillåt tvålager utan mesh",
        "allowTwoLayerHint": "Endast för stabila texturerade väggar",
        "oneLayerCeilings": "Enkellager tillåtet på tak",
        "oneLayerWalls": "Enkellager tillåtet på väggar",
        "twoLayerStableWalls": "Tvålager utan mesh på stabila texturerade väggar"
      },
      "mesh": {
        "title": "Mesh / Armering",
        "bathrooms": "Badrum",
        "edgeDistanceCm": "Mesharnas kantavstånd",
        "exteriors": "Fasader / utomhus",
        "floors": "Golv",
        "overlapCm": "Mesh-överlappning",
        "pools": "Pooler",
        "requiredFor": "Mesh obligatorisk för",
        "stairs": "Trappor",
        "tiles": "Kakel",
        "wood": "Trä"
      },
      "mixing": {
        "title": "Blandning och lager",
        "baseLayerThickness": "Grundlagertjocklek",
        "finishLayerThickness": "Finishlagertjocklek",
        "floorWaterRatio": "Vattenförhållande golv",
        "mixRestHint": "Vilotid efter blandning innan applicering",
        "mixRestMinutes": "Blandningsvilotid",
        "wallWaterRatio": "Vattenförhållande vägg"
      },
      "pool": {
        "title": "Poolregler",
        "fillWaitDays": "Väntetid innan fyllning",
        "fillWaitHint": "Minsta tid innan poolen fylls",
        "waterlineMarginCm": "HD-vattenlinjemarginal",
        "waterlineMarginHint": "Bredd på Heavy-Duty-zon runt vattenlinjen"
      },
      "presealer": {
        "title": "Presealer",
        "numberOfCoats": "Antal lager",
        "waitBetweenCoats": "Väntetid mellan lager"
      },
      "primer": {
        "title": "Primer",
        "maxWindowHint": "Lagret måste appliceras inom denna tid",
        "maxWindowHours": "Max. standardprimer-fönster",
        "minWaitHint": "Minsta väntetid innan det första lagret appliceras",
        "minWaitMinutes": "Min. väntetid standardprimer",
        "poolMinWaitHint": "Poolprimer — minsta väntetid innan coating",
        "poolMinWaitMinutes": "Min. väntetid poolprimer"
      },
      "sealer": {
        "title": "Standard-Sealer",
        "fullCureHours": "Fullständig härdning",
        "mixRestMinutes": "Blandningsvilotid",
        "numberOfCoats": "Antal lager",
        "ratioA": "Förhållande A",
        "ratioAHint": "Del A av blandningen (t.ex.: 5)",
        "ratioB": "Förhållande B",
        "ratioBHint": "Del B av blandningen (t.ex.: 1)",
        "waitBetweenCoats": "Väntetid mellan lager"
      },
      "substratePrep": {
        "title": "Underlagsförberedelse",
        "crackTreatment": "Sprickbehandling",
        "dustRemoval": "Dammavlägsning",
        "inspection": "Underlagsinspektion",
        "jointTreatment": "Fogbehandling",
        "maskingProtection": "Skydd av angränsande ytor",
        "maxImperfectionHint": "Gräns över vilken en fyllningsuppgift genereras",
        "maxImperfectionMm": "Max. ojämnhet",
        "sanding": "Slipning",
        "surfaceCleaning": "Ytrengöring"
      },
      "taskFamilies": {
        "title": "Aktivering av uppgiftsfamiljer",
        "description": "Att inaktivera en familj förhindrar att dessa uppgifter genereras i nya projekt. Befintliga uppgifter tas inte bort.",
        "aftercare": "Eftervård / skydd",
        "coating": "Finishlager",
        "drying": "Torktid",
        "handover": "Kundöverlämning (Handover)",
        "heavyDuty": "Heavy-Duty Sealer",
        "mesh": "Mesh / armering",
        "preparation": "Underlagsförberedelse",
        "presealer": "Presealer",
        "primer": "Primer",
        "qualityControl": "Kvalitetskontroll",
        "sealer": "Sealer"
      },
      "underfloorHeating": {
        "title": "Golvvärme",
        "clientWarningRapidHeatUp": "Kundvarning snabb uppvärmning",
        "controlsTitle": "Kontroller",
        "dailyTempCheck": "Daglig temperaturkontroll",
        "floorSurfaceTempCheck": "Golvtemperaturkontroll innan omstart",
        "generateClientHandover": "Överlämning av instruktioner till kund",
        "generateMonitoring": "Temperaturkontrolluppgifter",
        "generateProgressiveHeatUp": "Progressiv uppvärmning (uppgifter per dag)",
        "generateRestart": "Omstartsuppgifter för värmesystem",
        "generateShutdown": "Avstängningsuppgift för värmesystem",
        "generateTasks": "Generera golvvärmeuppgifter",
        "generationTitle": "Generering",
        "offDuringApplication": "Värme avstängd under applicering",
        "offDuringCure": "Värme avstängd under härdning",
        "requireQuestion": "Fråga om golvvärme för golvavsnitt",
        "restartAfterSealer": "Väntetid efter tätning innan omstart",
        "restartCompletionQc": "Slutlig QC efter omstart",
        "restartMaxTemp": "Maximal temperatur",
        "restartMinDuration": "Minsta uppgångstid",
        "restartRequiresValidation": "Validering krävs vid slutet",
        "restartStartTemp": "Starttemperatur",
        "restartTempIncrement": "Dagligt inkrement",
        "restartTitle": "Progressiv omstart",
        "shutdownBeforeApplication": "Timmar av avstängning innan applicering",
        "shutdownBeforeSealer": "Timmar av avstängning innan tätning",
        "shutdownTitle": "Avstängning innan applicering",
        "warning": "Att ändra omstartsparametrar kan påverka beläggningens prestanda. Ändra bara dessa värden i enlighet med Mas Mayas tekniska dokumentation."
      },
      "waterproofing": {
        "title": "Vattentätning",
        "bathrooms": "Membran krävs — badrum",
        "description": "Mas Maya-beläggningen är vattenresistent men inte vattentät. Ett vattentätande membran krävs i följande fall.",
        "pools": "Membran krävs — pooler",
        "wetZones": "Membran krävs — vattenutsatta ytor",
        "wetZonesHint": "Vattenutsatta ytor, direkt vattenexponering"
      }
    },
    "roomCalculation": {
      "title": "Rumsberäkning",
      "subtitle": "Koefficienter och parametrar för ytberäkning av sektioner av typen Rum",
      "resetTitle": "Återställ parametrar",
      "resetConfirm": "Alla värden ersätts med standardvärden. Denna åtgärd är irreversibel.",
      "surfaceCoefficients": {
        "title": "Ytkoefficienter",
        "subtitle": "Multiplikatorer applicerade på golvytan för att beräkna materialmängder",
        "walls": "Väggar",
        "wallsFormula": "väggyta = golv_m² × (höjdkoeff − takkoeff)",
        "wallsNote": "Väggkoefficienten härleds automatiskt från höjd- och takkoefficienterna.",
        "floorCoeff": "Golvkoefficient",
        "floorCoeffDesc": "Golvytemultiplikator (standard = 1)",
        "ceilingCoeff": "Takkoefficient",
        "ceilingCoeffDesc": "Takytemultiplikator (standard = 1)"
      },
      "calculationMode": {
        "title": "Standardberäkningsläge",
        "label": "Beräkningsmetod",
        "description": "Läge som används som standard när en Rum-sektion skapas",
        "method1": "Metod 1 — Snabbkoefficient",
        "method2": "Metod 2 — Exakta mått",
        "method3": "Metod 3 — Premium justerad"
      },
      "heightCoefficients": {
        "title": "Höjdkoefficienter",
        "subtitle": "Global ytkoefficient = golv_m² × koefficient (snabbmetod)"
      },
      "geometricMultipliers": {
        "title": "Geometriska multiplikatorer",
        "subtitle": "Justeringsfaktorer efter rumstyp",
        "colType": "Typ",
        "colLabel": "Etikett",
        "colMin": "Min",
        "colDefault": "Standard",
        "colMax": "Max"
      },
      "openingDeductions": {
        "title": "Avdragsregler för öppningar",
        "standardDoors": "Dra av standarddörrar",
        "standardWindows": "Dra av standardfönster",
        "largeBays": "Dra av stora fönsterpartier",
        "shopfronts": "Dra av butiksfasader",
        "largeGlassPartitions": "Dra av stora glasväggar",
        "thresholdLabel": "Avdragströskel för stora öppningar (m²)",
        "thresholdDesc": "Öppningar utöver detta tröskelvärde dras av om motsvarande regel är aktiverad"
      },
      "detailAdditions": {
        "title": "Detaljtillägg",
        "subtitle": "Tilläggsandel för arkitektoniska detaljer (returer, nischer, balkar, kassetter, pelare…)",
        "min": "Minimitillägg (%)",
        "default": "Standardtillägg (%)",
        "max": "Maximalt tillägg (%)"
      },
      "siteConditions": {
        "title": "Arbetsplatskonditionsmultiplikatorer",
        "subtitle": "Tillägg baserade på arbetsplatsens beläggningsstatus",
        "occupied": "Belagd / möblerad arbetsplats",
        "luxury": "Lyx- / ultra premium-arbetsplats",
        "minimum": "Minimalt (%)",
        "maximum": "Maximalt (%)"
      },
      "heightAccess": {
        "title": "Höjd-/tillträdesmultiplikatorer",
        "subtitle": "Tillägg baserade på takhöjd (tillträde, ställning)",
        "standardHeight": "Standardhöjd (0%)",
        "noAddition": "0% — inget tillägg"
      },
      "specialFormulas": {
        "title": "Speciella geometriska formler",
        "beams": "Balkar",
        "beamsFormula": "yta = längd × Σ synliga sidor",
        "beamsNote": "Lägg till varje synlig sida (undersida, sidor) × längd",
        "pillars": "Pelare",
        "pillarsFormula": "yta = omkrets × höjd",
        "pillarsNote": "Omkrets = summan av exponerade sidor",
        "slopedCeilings": "Lutande / snedtak",
        "slopedCeilingsFormula": "faktisk yta = projicerad yta / cos(vinkel)",
        "slopedCeilingsNote": "Vinkeln mäts från horisontalplanet",
        "niches": "Nischer",
        "nichesFormula": "bakvägg + vänster sida + höger sida + topp + botten + returer",
        "nichesNote": "Ange varje sida individuellt"
      }
    },
    "milestoneWorkflowDesigner": {
      "title": "Workflow Designer",
      "subtitle": "Konfigurera standardmilstolpeturen för varje nytt projekt.",
      "addMilestone": "Lägg till milstolpe",
      "saveMilestone": "Spara",
      "delete": "Ta bort",
      "unsavedChanges": "Osparade ändringar",
      "sections": {
        "identity": "Identitet",
        "triggerEngine": "Utlösningsmotor",
        "clientVisibility": "Kundsynlighet",
        "approvalGate": "Godkännandeport",
        "payment": "Betalning",
        "applicability": "Tillämpbarhet",
        "photoRules": "Fotoregler",
        "automation": "Automatisering",
        "notifications": "Notifikationer"
      },
      "fields": {
        "customTitle": "Anpassad titel",
        "color": "Färg",
        "icon": "Ikon",
        "type": "Typ",
        "scope": "Omfång",
        "triggerType": "Utlösare",
        "triggerCategories": "Utlösningskategorier",
        "blocksCategories": "Blockerade kategorier",
        "isVisibleToClient": "Synlig för kund",
        "notifyClient": "Meddela kund",
        "showPhotosToClient": "Visa foton för kund",
        "showProgress": "Visa framsteg",
        "requiresClientApproval": "Kräver kundgodkännande",
        "paymentType": "Betalningstyp",
        "paymentPercent": "Procentsats (%)",
        "paymentAmount": "Belopp (€)",
        "appliesToRenovation": "Renovering",
        "appliesToNewBuild": "Nybygge",
        "appliesToExternalOnly": "DIY / Extern",
        "appliesToManaged": "Mas Maya Hanterat",
        "appliesToExecuted": "Mas Maya Utfört",
        "requirePhotos": "Foton krävs",
        "minPhotos": "Minimifoton",
        "photosVisibleToClient": "Foton synliga för kund",
        "autoComplete": "Slutför automatiskt",
        "autoNotifyClient": "Meddela kund automatiskt",
        "autoLockDependentTasks": "Lås beroende uppgifter",
        "autoUnlockAfterApproval": "Lås upp efter godkännande",
        "notifyWorker": "Meddela montör",
        "notifyQm": "Meddela QM",
        "notifyPm": "Meddela PM"
      },
      "types": {
        "Progress": "Framsteg",
        "Approval": "Godkännande",
        "Payment": "Betalning"
      },
      "scopes": {
        "Project": "Projekt",
        "Section": "Sektion"
      },
      "triggerTypes": {
        "AllCategoriesCompleted": "Alla kategorier slutförda",
        "FirstTaskStarted": "Första uppgiften startad",
        "ProjectArchived": "Projekt arkiverat",
        "Manual": "Manuell"
      },
      "paymentTypes": {
        "None": "Ingen",
        "Percent": "Procentsats",
        "Fixed": "Fast belopp"
      },
      "categories": {
        "preparation": "Förberedelse",
        "primer": "Primer",
        "mesh": "Nät",
        "baseLayer": "Grundlager",
        "finishingLayer": "Ytskikt",
        "smoothing": "Utjämning",
        "presealer": "Presealer",
        "sealer": "Sealer",
        "heavyDutySealer": "Heavy-Duty Sealer",
        "curing": "Härdning",
        "delivery": "Leverans",
        "inspection": "Inspektion",
        "handover": "Överlämning",
        "custom": "Anpassad"
      },
      "executionModes": {
        "externalOnly": "DIY / Extern",
        "managed": "Mas Maya Hanterat",
        "executed": "Mas Maya Utfört"
      },
      "projectTypes": {
        "renovation": "Renovering",
        "newBuild": "Nybygge"
      }
    },
    "milestoneTemplateConfig": {
      "title": "Milstolpmallar",
      "description": "Dessa inställningar definierar de milstolpar som skapas automatiskt för varje nytt Mas Maya-projekt.",
      "projectMilestones": "Projektmilstolpar",
      "sectionMilestones": "Milstolpar per yta",
      "save": "Spara",
      "saveSuccess": "Konfiguration sparad.",
      "saveError": "Fel vid sparande.",
      "unsavedWarning": "Det finns osparade ändringar.",
      "m1": {
        "label": "Projekt startat",
        "hint": "Slutförs automatiskt när den första uppgiften startas."
      },
      "m2": {
        "label": "Förberedelse klar",
        "hint": "Slutförs när alla förberedelse- och primeruppgifter är klara."
      },
      "m3": {
        "label": "Ytgodkännande",
        "hint": "Utlöses per sektion när ytskikten är klara.",
        "requiresClientApproval": "Kundgodkännande krävs",
        "requiresClientApprovalHint": "Kunden får en unik länk för att godkänna eller avvisa varje yta."
      },
      "m4": {
        "label": "Skydd klart",
        "hint": "Slutförs när alla Presealer-, Sealer- och Heavy-Duty Sealer-uppgifter är klara."
      },
      "m5": {
        "label": "Leverans",
        "hint": "Slutförs automatiskt när projektet arkiveras.",
        "paymentType": "Betalningstyp",
        "paymentNone": "Ingen",
        "paymentPercent": "Procentsats",
        "paymentFixed": "Fast belopp",
        "paymentPercentLabel": "Procentsats (%)",
        "paymentAmountLabel": "Belopp (€)"
      }
    }
  },
  "staff": {
    "title": "Personal",
    "createButton": "Ny personalmedlem",
    "createTitle": "Lägg till personalmedlem",
    "noData": "Inga personalmedlemmar hittades",
    "manager": "Ansvarig",
    "setManager": "Gör till ansvarig",
    "removeManager": "Ta bort ansvarig-rollen",
    "showInactive": "Visa inaktiva",
    "managers": "Ansvariga",
    "activate": "Aktivera",
    "deactivate": "Inaktivera",
    "columns": {
      "name": "namn",
      "email": "e-post",
      "status": "status",
      "manager": "Chef"
    },
    "status": {
      "active": "aktiv",
      "inactive": "inaktiv"
    },
    "sections": {
      "profile": "profil"
    },
    "teaching": {
      "title": "Lärarcertifiering",
      "becomeTeacher": "Den här anställde är också lärare",
      "certifyTitle": "Certifiera som lärare",
      "editTitle": "Redigera certifiering",
      "editCertification": "Redigera certifiering"
    },
    "schedule": {
      "title": "Schema",
      "date": "Datum",
      "startTime": "Starttid",
      "endTime": "Sluttid",
      "type": "Typ",
      "project": "Projekt",
      "notes": "anteckningar",
      "addEntry": "Lägg till post",
      "empty": "Inga schemaposter",
      "removeTitle": "Ta bort post",
      "removeConfirm": "Är du säker på att du vill ta bort denna schemapost?"
    },
    "scheduleType": {
      "ProjectAssignment": "Projekttilldelning",
      "TrainingSession": "Utbildningstillfälle",
      "Unavailable": "Ej tillgänglig"
    },
    "assignedProjects": "Tilldelade projekt",
    "noAssignedProjects": "Inga tilldelade projekt",
    "rolePM": "Projektledare",
    "roleBackupPM": "Ersättande projektledare",
    "form": {
      "notes": "anteckningar",
      "firstName": "Förnamn",
      "firstNamePlaceholder": "John",
      "lastName": "Efternamn",
      "lastNamePlaceholder": "Doe",
      "emailRequired": "e-post is obligatorisk",
      "firstNameRequired": "Förnamn är obligatoriskt",
      "lastNameRequired": "Efternamn är obligatoriskt",
      "email": "e-post"
    }
  },
  "structures": {
    "title": "Struktur",
    "type": "Strukturtyp",
    "noStructure": "Ingen struktur definierad",
    "define": "Definiera struktur",
    "computedSurface": "Beräknad yta",
    "computedVolume": "Beräknad volym",
    "deleteTitle": "Ta bort struktur",
    "deleteConfirm": "Ta bort strukturdefinitionen för denna sektion? Ytan kommer inte att beräknas om."
  },
  "calendar": {
    "title": "Kalender",
    "mode": {
      "project": "Per projekt",
      "staff": "Per anställd"
    },
    "labels": {
      "today": "Idag",
      "day": "Dag",
      "week": "Vecka",
      "month": "Månad",
      "year": "År"
    },
    "filters": {
      "categories": "Visa",
      "allProjects": "Alla projekt",
      "selectProject": "Välj ett projekt",
      "selectStaff": "Välj en anställd",
      "allStatuses": "Alla statusar",
      "allStepTypes": "Alla stegtyper",
      "allStaff": "All personal",
      "allAccounts": "Alla konton"
    },
    "categories": {
      "ProjectStep": "Projektsteg",
      "DryingPeriod": "Torkning",
      "CuringPeriod": "Härdning",
      "Delivery": "Leverans",
      "Training": "Utbildning",
      "StaffSchedule": "Bemanning",
      "Supervision": "Tillsyn",
      "Personal": "Personligt",
      "ProjectTask": "Projektuppgift"
    },
    "taskStatuses": {
      "Todo": "Att göra",
      "InProgress": "Pågående",
      "SubmittedForReview": "Inskickad för granskning",
      "ValidatedAsTechnicallyCompliant": "Validerad",
      "RejectedWithCorrectionRequired": "Avvisad — korrigering krävs",
      "Blocked": "Blockerad"
    },
    "taskCategories": {
      "Preparation": "Förberedelse",
      "Primer": "Grundning",
      "Mesh": "Nät",
      "BaseLayer": "Grundlager",
      "FinishingLayer": "Ytskikt",
      "Smoothing": "Utjämning",
      "Presealer": "Presealer",
      "Sealer": "Sealer",
      "HeavyDutySealer": "Kraftig sealer",
      "Curing": "Härdning",
      "Delivery": "Leverans",
      "Inspection": "Inspektion",
      "Handover": "Överlämning",
      "Custom": "Anpassad"
    },
    "taskPriorities": {
      "Low": "Low",
      "Normal": "Normal",
      "High": "Hög",
      "Critical": "Kritisk"
    },
    "stepTypes": {
      "SubstratePreparation": "Underlagsförberedelse",
      "PrimerApplication": "Primer",
      "BaseLayer": "Grundlager",
      "MeshInstallation": "Nätinstallation",
      "FinishingCoat": "Ytlager",
      "Smoothing": "Utjämning",
      "Presealer": "Pre-sealer",
      "Sealer": "Sealer",
      "HeavyDutySealer": "Kraftig sealer",
      "CuringStep": "Härdning",
      "ProtectionPeriod": "Skyddsperiod",
      "Handover": "Överlämning"
    },
    "stepStatuses": {
      "Planned": "Planerat",
      "InProgress": "Pågående",
      "Completed": "Avslutat",
      "Blocked": "Blockerad",
      "ValidationPending": "Väntar på validering",
      "CorrectionRequired": "Korrigering krävs",
      "Cancelled": "Avbruten"
    },
    "deliveryTypes": {
      "OrderConfirmed": "Beställning bekräftad",
      "OrderPrepared": "Beställning förberedd",
      "DeliveryExpected": "Leverans förväntad",
      "DeliveryDelayed": "Leverans försenad",
      "DeliveryCompleted": "Levererad"
    },
    "deliveryStatuses": {
      "Pending": "Väntande",
      "InTransit": "Under transport",
      "Delivered": "Levererad",
      "Delayed": "Försenad",
      "Cancelled": "Avbruten"
    },
    "scheduleEntryTypes": {
      "ProjectAssignment": "Projekttilldelning",
      "TrainingSession": "Utbildningstillfälle",
      "Unavailable": "Ej tillgänglig"
    },
    "detail": {
      "start": "Start",
      "end": "Slut",
      "project": "Projekt",
      "section": "Avsnitt",
      "stepType": "Stegtyp",
      "status": "Status",
      "blocked": "Blockerad",
      "drying": "Torkningsperiod",
      "curing": "Härdningsperiod",
      "deliveryType": "Leveranstyp",
      "deliveryStatus": "Leveransstatus",
      "trackingNumber": "Spårningsnummer",
      "carrier": "Transportör",
      "location": "Plats",
      "staffMember": "Teammedlem",
      "entryType": "Posttyp",
      "notes": "Anteckningar",
      "deleteConfirm": "Är du säker på att du vill ta bort denna händelse? Denna åtgärd kan inte ångras.",
      "taskStatus": "Status",
      "taskCategory": "Kategori",
      "taskPriority": "Prioritet",
      "assignedApplicator": "Applikatör",
      "assignedManager": "Projektledare",
      "validationRequired": "Validering krävs",
      "noPlannedDate": "Inget planerat datum — placerad på projektets startdatum"
    },
    "modal": {
      "createStep": "Skapa projektsteg",
      "editStep": "Redigera projektsteg",
      "createDelivery": "Skapa leverans",
      "editDelivery": "Redigera leverans",
      "project": "Projekt",
      "stepType": "Stegtyp",
      "customTitle": "Anpassad titel",
      "customTitlePlaceholder": "Lämna tomt för att använda stegtypens namn",
      "date": "Datum",
      "startTime": "Starttid",
      "endTime": "Sluttid",
      "dryingHours": "Torkning (timmar)",
      "curingHours": "Härdning (timmar)",
      "status": "Status",
      "notes": "anteckningar",
      "isBlocked": "Blockerad",
      "blockedReason": "Blockeringsorsak",
      "deliveryType": "Leveranstyp",
      "deliveryStatus": "Status",
      "expectedDate": "Förväntat datum",
      "actualDate": "Faktiskt leveransdatum",
      "trackingNumber": "Spårningsnummer",
      "carrier": "Transportör"
    }
  },
  "supervision": {
    "title": "Övervakning",
    "tabs": {
      "comments": "Kommentarer",
      "observations": "Observationer",
      "escalations": "Eskaleringar",
      "history": "Historik"
    },
    "visibility": {
      "label": "Synlighet",
      "ClientVisible": "Synlig för kund",
      "TeamVisible": "Endast team",
      "InternalOnly": "Endast internt"
    },
    "comments": {
      "empty": "Inga kommentarer än.",
      "newPlaceholder": "Skriv en kommentar…",
      "replyPlaceholder": "Skriv ett svar…",
      "send": "Skicka",
      "reply": "Svara",
      "deleted": "[borttagen]"
    },
    "observations": {
      "empty": "Inga observationer registrerade.",
      "open": "öppen",
      "resolvedCount": "lösta",
      "add": "Lägg till observation",
      "titleLabel": "Titel",
      "bodyLabel": "beskrivning",
      "severityLabel": "Allvarlighetsgrad",
      "by": "av",
      "resolved": "Löst",
      "resolve": "Markera som löst",
      "confirmResolve": "Bekräfta",
      "resolutionNote": "Lösningsanteckning",
      "resolveNotePlaceholder": "Beskriv hur detta löstes…",
      "severity": {
        "Info": "Info",
        "Warning": "varning",
        "Critical": "Kritisk"
      }
    },
    "escalations": {
      "empty": "Inga eskaleringar.",
      "open": "öppen",
      "resolvedCount": "lösta",
      "new": "Ny eskalering",
      "subjectLabel": "Ämne",
      "bodyLabel": "beskrivning",
      "submit": "Skicka",
      "by": "av",
      "assignedTo": "Tilldelad till",
      "resolution": "Lösning",
      "resolutionLabel": "Lösningsanteckning",
      "statusLabel": "ny status",
      "updateStatus": "uppdatera status",
      "status": {
        "Open": "Öppen",
        "Acknowledged": "Bekräftad",
        "Resolved": "Löst"
      }
    },
    "auditLog": {
      "empty": "Ingen aktivitet registrerad än.",
      "loadMore": "Visa fler",
      "actions": {
        "ProjectCreated": "skapade projektet",
        "ProjectUpdated": "uppdaterade projektet",
        "ProjectStatusChanged": "ändrade projektstatus",
        "ProjectDeleted": "tog bort projektet",
        "StepCreated": "skapade ett steg",
        "StepUpdated": "uppdaterade ett steg",
        "StepStatusChanged": "ändrade status för ett steg",
        "StepDeleted": "tog bort ett steg",
        "StepBlocked": "blockerade ett steg",
        "StepUnblocked": "avblockerade ett steg",
        "StepValidated": "validerade ett steg",
        "StepRejected": "avvisade ett steg",
        "DeliveryCreated": "skapade en leverans",
        "DeliveryUpdated": "uppdaterade en leverans",
        "DeliveryStatusChanged": "ändrade leveransstatus",
        "DeliveryDeleted": "tog bort en leverans",
        "ApplicatorAssigned": "tilldelade en applikatör",
        "ApplicatorRemoved": "tog bort en applikatör",
        "TeamMemberAssigned": "tilldelade en teammedlem",
        "TeamMemberRemoved": "tog bort en teammedlem",
        "BackupPmAssigned": "tilldelade en ersättande projektledare",
        "ClientLinked": "länkade en kund",
        "DocumentUploaded": "laddade upp ett dokument",
        "DocumentDeleted": "tog bort ett dokument",
        "CommentAdded": "lade till en kommentar",
        "CommentDeleted": "tog bort en kommentar",
        "ObservationAdded": "registrerade en observation",
        "ObservationResolved": "löste en observation",
        "EscalationCreated": "skapade en eskalering",
        "EscalationAcknowledged": "bekräftade en eskalering",
        "EscalationResolved": "löste en eskalering"
      }
    }
  },
  "roles": {
    "GlobalAdmin": "Superadministratör",
    "Admin": "Administratör",
    "ProjectManager": "Projektledare",
    "BackupProjectManager": "Ersättande projektledare",
    "MasMayaApplicator": "Mas Maya-applikatör",
    "ReferencedInstaller": "Refererad installatör",
    "IndividualClient": "Privatkund",
    "ProfessionalClient": "Företagskund"
  },
  "userManagement": {
    "title": "Användarhantering",
    "users": "användare",
    "searchPlaceholder": "Sök efter namn eller e-post…",
    "noRoles": "Inga roller tilldelade",
    "noUsers": "Inga användare hittades",
    "addRole": "Lägg till roll",
    "columns": {
      "user": "Användare",
      "roles": "Roller",
      "entities": "Enheter"
    },
    "removeRole": {
      "title": "Ta bort roll",
      "confirm": "Ta bort rollen {{role}} från {{user}}?"
    },
    "impersonate": "Imitera",
    "impersonatingAs": "Inloggad som {{name}}",
    "stopImpersonating": "Sluta imitera"
  },
  "shop": {
    "nav": "Butik",
    "hero": {
      "title": "Ytbehandlingssystem",
      "subtitle": "Beläggningar, primers och tillbehör",
      "description": "Arkitektoniska ytmaterial för krävande hantverkare."
    },
    "allProducts": "Alla produkter",
    "searchPlaceholder": "Sök produkter...",
    "noResults": "Inga produkter hittades",
    "filterBy": "Filtrera efter",
    "sortBy": "Sortera efter",
    "sort": {
      "nameAsc": "Namn (A–Ö)",
      "priceAsc": "Pris: lågt till högt",
      "priceDesc": "Pris: högt till lågt"
    },
    "addToCart": "Lägg i kundvagn",
    "addedToCart": "Tillagd i kundvagn",
    "viewDetails": "Visa produkt",
    "backToShop": "Tillbaka till butiken",
    "relatedProducts": "Kompletterande produkter",
    "systemNote": "Dessa produkter ingår i ett komplett appliceringssystem.",
    "selectContact": "Välj en kund",
    "selectContactHint": "Välj en kund för att hantera deras kundvagn.",
    "cartFor": "Kundvagn för",
    "openCart": "Visa kundvagn",
    "cart": {
      "title": "Kundvagn",
      "empty": "Kundvagnen är tom.",
      "checkout": "Till kassan",
      "orderOnMasmaya": "Beställ på masmaya.com"
    },
    "qty": "Antal",
    "details": {
      "category": "Kategori",
      "variant": "Variant",
      "color": "Färg",
      "sizeWeight": "Storlek / Vikt",
      "dimensions": "Mått",
      "sku": "Referens",
      "price": "pris",
      "technical": "Teknisk information"
    }
  },
  "applicatorProfiles": {
    "title": "Applikatörsprofiler",
    "createTitle": "Skapa applikaturprofil",
    "moderateTitle": "Moderera portföljpost",
    "form": {
      "contactId": "Kontakt-ID",
      "contactIdPlaceholder": "Klistra in kontaktens UUID",
      "contactIdRequired": "Kontakt-ID krävs",
      "displayName": "Visningsnamn",
      "displayNameRequired": "Visningsnamn krävs",
      "companyName": "Företagsnamn",
      "bio": "Biografi",
      "city": "Stad",
      "country": "Land (2-bokstavskod)",
      "travelRadius": "Resradie (km)",
      "yearsExperience": "Års erfarenhet",
      "availability": "Tillgänglighet",
      "specialties": "Specialiteter",
      "styleTags": "Stiltaggar",
      "technicalTags": "Tekniska system",
      "note": "Notering (synlig endast för admin)",
      "newStatus": "Ny status"
    },
    "availability": {
      "Available": "Tillgänglig",
      "PartiallyBooked": "Delvis bokad",
      "Unavailable": "Otillgänglig"
    },
    "moderation": {
      "PendingReview": "Granskning väntande",
      "Approved": "Godkänd",
      "Rejected": "Avvisad",
      "Hidden": "Dold",
      "Featured": "Utvald"
    },
    "currentStatus": "Aktuell status:",
    "deleteConfirm": "Ta bort denna applikaturprofil?",
    "deleteTitle": "Ta bort profil"
  }
}
